/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as TermsImport } from './routes/terms'
import { Route as PrivacyImport } from './routes/privacy'
import { Route as ContactImport } from './routes/contact'
import { Route as AppImport } from './routes/_app'
import { Route as IndexImport } from './routes/index'
import { Route as ConflictCheckTokenImport } from './routes/conflict-check.$token'
import { Route as AppDevImport } from './routes/_app/_dev'
import { Route as AppAuthImport } from './routes/_app/_auth'
import { Route as AppLoginLayoutImport } from './routes/_app/login/_layout'
import { Route as AppDevComponentLibraryImport } from './routes/_app/_dev/component-library'
import { Route as AppLoginLayoutIndexImport } from './routes/_app/login/_layout.index'
import { Route as AppAuthOnboardingLayoutImport } from './routes/_app/_auth/onboarding/_layout'
import { Route as AppAuthDashboardLayoutImport } from './routes/_app/_auth/dashboard/_layout'
import { Route as AppAuthAdminLayoutImport } from './routes/_app/_auth/admin/_layout'
import { Route as AppAuthDashboardLayoutIndexImport } from './routes/_app/_auth/dashboard/_layout.index'
import { Route as AppAuthAdminLayoutIndexImport } from './routes/_app/_auth/admin/_layout.index'
import { Route as AppAuthOnboardingLayoutOrganizationImport } from './routes/_app/_auth/onboarding/_layout.organization'
import { Route as AppAuthDashboardLayoutWorkflowsImport } from './routes/_app/_auth/dashboard/_layout.workflows'
import { Route as AppAuthDashboardLayoutWorkflowRolesImport } from './routes/_app/_auth/dashboard/_layout.workflow-roles'
import { Route as AppAuthDashboardLayoutTimesheetsImport } from './routes/_app/_auth/dashboard/_layout.timesheets'
import { Route as AppAuthDashboardLayoutTimesheetSettingsImport } from './routes/_app/_auth/dashboard/_layout.timesheet-settings'
import { Route as AppAuthDashboardLayoutTimesheetReportsImport } from './routes/_app/_auth/dashboard/_layout.timesheet-reports'
import { Route as AppAuthDashboardLayoutTimesheetApprovalsImport } from './routes/_app/_auth/dashboard/_layout.timesheet-approvals'
import { Route as AppAuthDashboardLayoutTaskStatusesImport } from './routes/_app/_auth/dashboard/_layout.task-statuses'
import { Route as AppAuthDashboardLayoutTaskLabelsImport } from './routes/_app/_auth/dashboard/_layout.task-labels'
import { Route as AppAuthDashboardLayoutSettingsImport } from './routes/_app/_auth/dashboard/_layout.settings'
import { Route as AppAuthDashboardLayoutPreAppointmentStatusesImport } from './routes/_app/_auth/dashboard/_layout.pre-appointment-statuses'
import { Route as AppAuthDashboardLayoutPreAppointmentSettingsImport } from './routes/_app/_auth/dashboard/_layout.pre-appointment-settings'
import { Route as AppAuthDashboardLayoutPreAppointmentLabelsImport } from './routes/_app/_auth/dashboard/_layout.pre-appointment-labels'
import { Route as AppAuthDashboardLayoutPreAppointmentFieldsImport } from './routes/_app/_auth/dashboard/_layout.pre-appointment-fields'
import { Route as AppAuthDashboardLayoutPreAppointmentImport } from './routes/_app/_auth/dashboard/_layout.pre-appointment'
import { Route as AppAuthDashboardLayoutMyTasksImport } from './routes/_app/_auth/dashboard/_layout.my-tasks'
import { Route as AppAuthDashboardLayoutMailImport } from './routes/_app/_auth/dashboard/_layout.mail'
import { Route as AppAuthDashboardLayoutJobsImport } from './routes/_app/_auth/dashboard/_layout.jobs'
import { Route as AppAuthDashboardLayoutInboxImport } from './routes/_app/_auth/dashboard/_layout.inbox'
import { Route as AppAuthDashboardLayoutFirmContactsImport } from './routes/_app/_auth/dashboard/_layout.firm-contacts'
import { Route as AppAuthDashboardLayoutCheckoutImport } from './routes/_app/_auth/dashboard/_layout.checkout'
import { Route as AppAuthDashboardLayoutCalendarImport } from './routes/_app/_auth/dashboard/_layout.calendar'
import { Route as AppAuthDashboardLayoutAutomationsImport } from './routes/_app/_auth/dashboard/_layout.automations'
import { Route as AppAuthDashboardLayoutAgentImport } from './routes/_app/_auth/dashboard/_layout.agent'
import { Route as AppAuthAdminLayoutUsersImport } from './routes/_app/_auth/admin/_layout.users'
import { Route as AppAuthAdminLayoutReductoImport } from './routes/_app/_auth/admin/_layout.reducto'
import { Route as AppAuthAdminLayoutOrganisationsImport } from './routes/_app/_auth/admin/_layout.organisations'
import { Route as AppAuthAdminLayoutMasterLibraryImport } from './routes/_app/_auth/admin/_layout.master-library'
import { Route as AppAuthAdminLayoutInvitationsImport } from './routes/_app/_auth/admin/_layout.invitations'
import { Route as AppAuthAdminLayoutInfotrackImport } from './routes/_app/_auth/admin/_layout.infotrack'
import { Route as AppAuthAdminLayoutEmailTemplatesImport } from './routes/_app/_auth/admin/_layout.email-templates'
import { Route as AppAuthAdminLayoutCostManagementImport } from './routes/_app/_auth/admin/_layout.cost-management'
import { Route as AppAuthAdminLayoutBillingImport } from './routes/_app/_auth/admin/_layout.billing'
import { Route as AppAuthAdminLayoutAiUsageImport } from './routes/_app/_auth/admin/_layout.ai-usage'
import { Route as AppAuthDashboardLayoutWorkflowsIndexImport } from './routes/_app/_auth/dashboard/_layout.workflows.index'
import { Route as AppAuthDashboardLayoutSettingsIndexImport } from './routes/_app/_auth/dashboard/_layout.settings.index'
import { Route as AppAuthDashboardLayoutJobsIndexImport } from './routes/_app/_auth/dashboard/_layout.jobs.index'
import { Route as AppAuthDashboardLayoutFirmContactsIndexImport } from './routes/_app/_auth/dashboard/_layout.firm-contacts.index'
import { Route as AppAuthDashboardLayoutWorkflowsWorkflowIdImport } from './routes/_app/_auth/dashboard/_layout.workflows.$workflowId'
import { Route as AppAuthDashboardLayoutSettingsSnippetsImport } from './routes/_app/_auth/dashboard/_layout.settings.snippets'
import { Route as AppAuthDashboardLayoutSettingsReportTemplatesImport } from './routes/_app/_auth/dashboard/_layout.settings.report-templates'
import { Route as AppAuthDashboardLayoutSettingsPublicHolidaysImport } from './routes/_app/_auth/dashboard/_layout.settings.public-holidays'
import { Route as AppAuthDashboardLayoutSettingsOrganizationImport } from './routes/_app/_auth/dashboard/_layout.settings.organization'
import { Route as AppAuthDashboardLayoutSettingsJobcodeImport } from './routes/_app/_auth/dashboard/_layout.settings.jobcode'
import { Route as AppAuthDashboardLayoutSettingsIntegrationsImport } from './routes/_app/_auth/dashboard/_layout.settings.integrations'
import { Route as AppAuthDashboardLayoutSettingsHelpImport } from './routes/_app/_auth/dashboard/_layout.settings.help'
import { Route as AppAuthDashboardLayoutSettingsFieldsImport } from './routes/_app/_auth/dashboard/_layout.settings.fields'
import { Route as AppAuthDashboardLayoutSettingsDocsImport } from './routes/_app/_auth/dashboard/_layout.settings.docs'
import { Route as AppAuthDashboardLayoutSettingsContactRolesImport } from './routes/_app/_auth/dashboard/_layout.settings.contact-roles'
import { Route as AppAuthDashboardLayoutSettingsBrandingImport } from './routes/_app/_auth/dashboard/_layout.settings.branding'
import { Route as AppAuthDashboardLayoutSettingsBillingImport } from './routes/_app/_auth/dashboard/_layout.settings.billing'
import { Route as AppAuthDashboardLayoutJobsJobIdImport } from './routes/_app/_auth/dashboard/_layout.jobs.$jobId'
import { Route as AppAuthDashboardLayoutFirmContactsFieldsImport } from './routes/_app/_auth/dashboard/_layout.firm-contacts.fields'
import { Route as AppAuthDashboardLayoutFirmContactsCategoriesImport } from './routes/_app/_auth/dashboard/_layout.firm-contacts.categories'
import { Route as AppAuthAdminLayoutUsersUserIdImport } from './routes/_app/_auth/admin/_layout.users.$userId'
import { Route as AppAuthAdminLayoutOrganisationsOrgIdImport } from './routes/_app/_auth/admin/_layout.organisations.$orgId'
import { Route as AppAuthDashboardLayoutJobsJobIdIndexImport } from './routes/_app/_auth/dashboard/_layout.jobs.$jobId.index'
import { Route as AppAuthDashboardLayoutJobsJobIdTimesheetsImport } from './routes/_app/_auth/dashboard/_layout.jobs.$jobId.timesheets'
import { Route as AppAuthDashboardLayoutJobsJobIdSummariesImport } from './routes/_app/_auth/dashboard/_layout.jobs.$jobId.summaries'
import { Route as AppAuthDashboardLayoutJobsJobIdSettingsImport } from './routes/_app/_auth/dashboard/_layout.jobs.$jobId.settings'
import { Route as AppAuthDashboardLayoutJobsJobIdSearchesImport } from './routes/_app/_auth/dashboard/_layout.jobs.$jobId.searches'
import { Route as AppAuthDashboardLayoutJobsJobIdReviewImport } from './routes/_app/_auth/dashboard/_layout.jobs.$jobId.review'
import { Route as AppAuthDashboardLayoutJobsJobIdReportingImport } from './routes/_app/_auth/dashboard/_layout.jobs.$jobId.reporting'
import { Route as AppAuthDashboardLayoutJobsJobIdRecoveriesImport } from './routes/_app/_auth/dashboard/_layout.jobs.$jobId.recoveries'
import { Route as AppAuthDashboardLayoutJobsJobIdPlanImport } from './routes/_app/_auth/dashboard/_layout.jobs.$jobId.plan'
import { Route as AppAuthDashboardLayoutJobsJobIdMailImport } from './routes/_app/_auth/dashboard/_layout.jobs.$jobId.mail'
import { Route as AppAuthDashboardLayoutJobsJobIdGeneratePrecedentsImport } from './routes/_app/_auth/dashboard/_layout.jobs.$jobId.generate-precedents'
import { Route as AppAuthDashboardLayoutJobsJobIdGatherInformationImport } from './routes/_app/_auth/dashboard/_layout.jobs.$jobId.gather-information'
import { Route as AppAuthDashboardLayoutJobsJobIdGatherImport } from './routes/_app/_auth/dashboard/_layout.jobs.$jobId.gather'
import { Route as AppAuthDashboardLayoutJobsJobIdDayOneImport } from './routes/_app/_auth/dashboard/_layout.jobs.$jobId.day-one'
import { Route as AppAuthDashboardLayoutJobsJobIdContactsImport } from './routes/_app/_auth/dashboard/_layout.jobs.$jobId.contacts'
import { Route as AppAuthDashboardLayoutJobsJobIdCalendarImport } from './routes/_app/_auth/dashboard/_layout.jobs.$jobId.calendar'
import { Route as AppAuthDashboardLayoutJobsJobIdAgentImport } from './routes/_app/_auth/dashboard/_layout.jobs.$jobId.agent'
import { Route as AppAuthDashboardLayoutJobsJobIdSummariesIndexImport } from './routes/_app/_auth/dashboard/_layout.jobs.$jobId.summaries.index'
import { Route as AppAuthDashboardLayoutJobsJobIdSearchesIndexImport } from './routes/_app/_auth/dashboard/_layout.jobs.$jobId.searches.index'
import { Route as AppAuthDashboardLayoutJobsJobIdReviewIndexImport } from './routes/_app/_auth/dashboard/_layout.jobs.$jobId.review.index'
import { Route as AppAuthDashboardLayoutJobsJobIdRecoveriesIndexImport } from './routes/_app/_auth/dashboard/_layout.jobs.$jobId.recoveries.index'
import { Route as AppAuthDashboardLayoutJobsJobIdGatherIndexImport } from './routes/_app/_auth/dashboard/_layout.jobs.$jobId.gather.index'
import { Route as AppAuthDashboardLayoutJobsJobIdCalendarIndexImport } from './routes/_app/_auth/dashboard/_layout.jobs.$jobId.calendar.index'
import { Route as AppAuthDashboardLayoutJobsJobIdSummariesAgentImport } from './routes/_app/_auth/dashboard/_layout.jobs.$jobId.summaries.$agent'
import { Route as AppAuthDashboardLayoutJobsJobIdSearchesWebImport } from './routes/_app/_auth/dashboard/_layout.jobs.$jobId.searches.web'
import { Route as AppAuthDashboardLayoutJobsJobIdSearchesKycAmlImport } from './routes/_app/_auth/dashboard/_layout.jobs.$jobId.searches.kyc-aml'
import { Route as AppAuthDashboardLayoutJobsJobIdSearchesInfotrackImport } from './routes/_app/_auth/dashboard/_layout.jobs.$jobId.searches.infotrack'
import { Route as AppAuthDashboardLayoutJobsJobIdReviewAgentImport } from './routes/_app/_auth/dashboard/_layout.jobs.$jobId.review.$agent'
import { Route as AppAuthDashboardLayoutJobsJobIdRecoveriesSectionImport } from './routes/_app/_auth/dashboard/_layout.jobs.$jobId.recoveries.$section'
import { Route as AppAuthDashboardLayoutJobsJobIdCalendarTasksImport } from './routes/_app/_auth/dashboard/_layout.jobs.$jobId.calendar.tasks'
import { Route as AppAuthDashboardLayoutJobsJobIdCalendarReviewWindowsImport } from './routes/_app/_auth/dashboard/_layout.jobs.$jobId.calendar.review-windows'
import { Route as AppAuthDashboardLayoutJobsJobIdCalendarOverviewImport } from './routes/_app/_auth/dashboard/_layout.jobs.$jobId.calendar.overview'

// Create Virtual Routes

const AppLoginImport = createFileRoute('/_app/login')()
const AppAuthOnboardingImport = createFileRoute('/_app/_auth/onboarding')()
const AppAuthDashboardImport = createFileRoute('/_app/_auth/dashboard')()
const AppAuthAdminImport = createFileRoute('/_app/_auth/admin')()

// Create/Update Routes

const TermsRoute = TermsImport.update({
  path: '/terms',
  getParentRoute: () => rootRoute,
} as any)

const PrivacyRoute = PrivacyImport.update({
  path: '/privacy',
  getParentRoute: () => rootRoute,
} as any)

const ContactRoute = ContactImport.update({
  path: '/contact',
  getParentRoute: () => rootRoute,
} as any)

const AppRoute = AppImport.update({
  id: '/_app',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AppLoginRoute = AppLoginImport.update({
  path: '/login',
  getParentRoute: () => AppRoute,
} as any)

const ConflictCheckTokenRoute = ConflictCheckTokenImport.update({
  path: '/conflict-check/$token',
  getParentRoute: () => rootRoute,
} as any)

const AppDevRoute = AppDevImport.update({
  id: '/_dev',
  getParentRoute: () => AppRoute,
} as any)

const AppAuthRoute = AppAuthImport.update({
  id: '/_auth',
  getParentRoute: () => AppRoute,
} as any)

const AppAuthOnboardingRoute = AppAuthOnboardingImport.update({
  path: '/onboarding',
  getParentRoute: () => AppAuthRoute,
} as any)

const AppAuthDashboardRoute = AppAuthDashboardImport.update({
  path: '/dashboard',
  getParentRoute: () => AppAuthRoute,
} as any)

const AppAuthAdminRoute = AppAuthAdminImport.update({
  path: '/admin',
  getParentRoute: () => AppAuthRoute,
} as any)

const AppLoginLayoutRoute = AppLoginLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => AppLoginRoute,
} as any)

const AppDevComponentLibraryRoute = AppDevComponentLibraryImport.update({
  path: '/component-library',
  getParentRoute: () => AppDevRoute,
} as any)

const AppLoginLayoutIndexRoute = AppLoginLayoutIndexImport.update({
  path: '/',
  getParentRoute: () => AppLoginLayoutRoute,
} as any)

const AppAuthOnboardingLayoutRoute = AppAuthOnboardingLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => AppAuthOnboardingRoute,
} as any)

const AppAuthDashboardLayoutRoute = AppAuthDashboardLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => AppAuthDashboardRoute,
} as any)

const AppAuthAdminLayoutRoute = AppAuthAdminLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => AppAuthAdminRoute,
} as any)

const AppAuthDashboardLayoutIndexRoute =
  AppAuthDashboardLayoutIndexImport.update({
    path: '/',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)

const AppAuthAdminLayoutIndexRoute = AppAuthAdminLayoutIndexImport.update({
  path: '/',
  getParentRoute: () => AppAuthAdminLayoutRoute,
} as any)

const AppAuthOnboardingLayoutOrganizationRoute =
  AppAuthOnboardingLayoutOrganizationImport.update({
    path: '/organization',
    getParentRoute: () => AppAuthOnboardingLayoutRoute,
  } as any)

const AppAuthDashboardLayoutWorkflowsRoute =
  AppAuthDashboardLayoutWorkflowsImport.update({
    path: '/workflows',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)

const AppAuthDashboardLayoutWorkflowRolesRoute =
  AppAuthDashboardLayoutWorkflowRolesImport.update({
    path: '/workflow-roles',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)

const AppAuthDashboardLayoutTimesheetsRoute =
  AppAuthDashboardLayoutTimesheetsImport.update({
    path: '/timesheets',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)

const AppAuthDashboardLayoutTimesheetSettingsRoute =
  AppAuthDashboardLayoutTimesheetSettingsImport.update({
    path: '/timesheet-settings',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)

const AppAuthDashboardLayoutTimesheetReportsRoute =
  AppAuthDashboardLayoutTimesheetReportsImport.update({
    path: '/timesheet-reports',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)

const AppAuthDashboardLayoutTimesheetApprovalsRoute =
  AppAuthDashboardLayoutTimesheetApprovalsImport.update({
    path: '/timesheet-approvals',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)

const AppAuthDashboardLayoutTaskStatusesRoute =
  AppAuthDashboardLayoutTaskStatusesImport.update({
    path: '/task-statuses',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)

const AppAuthDashboardLayoutTaskLabelsRoute =
  AppAuthDashboardLayoutTaskLabelsImport.update({
    path: '/task-labels',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)

const AppAuthDashboardLayoutSettingsRoute =
  AppAuthDashboardLayoutSettingsImport.update({
    path: '/settings',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)

const AppAuthDashboardLayoutPreAppointmentStatusesRoute =
  AppAuthDashboardLayoutPreAppointmentStatusesImport.update({
    path: '/pre-appointment-statuses',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)

const AppAuthDashboardLayoutPreAppointmentSettingsRoute =
  AppAuthDashboardLayoutPreAppointmentSettingsImport.update({
    path: '/pre-appointment-settings',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)

const AppAuthDashboardLayoutPreAppointmentLabelsRoute =
  AppAuthDashboardLayoutPreAppointmentLabelsImport.update({
    path: '/pre-appointment-labels',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)

const AppAuthDashboardLayoutPreAppointmentFieldsRoute =
  AppAuthDashboardLayoutPreAppointmentFieldsImport.update({
    path: '/pre-appointment-fields',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)

const AppAuthDashboardLayoutPreAppointmentRoute =
  AppAuthDashboardLayoutPreAppointmentImport.update({
    path: '/pre-appointment',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)

const AppAuthDashboardLayoutMyTasksRoute =
  AppAuthDashboardLayoutMyTasksImport.update({
    path: '/my-tasks',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)

const AppAuthDashboardLayoutMailRoute = AppAuthDashboardLayoutMailImport.update(
  {
    path: '/mail',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any,
)

const AppAuthDashboardLayoutJobsRoute = AppAuthDashboardLayoutJobsImport.update(
  {
    path: '/jobs',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any,
)

const AppAuthDashboardLayoutInboxRoute =
  AppAuthDashboardLayoutInboxImport.update({
    path: '/inbox',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)

const AppAuthDashboardLayoutFirmContactsRoute =
  AppAuthDashboardLayoutFirmContactsImport.update({
    path: '/firm-contacts',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)

const AppAuthDashboardLayoutCheckoutRoute =
  AppAuthDashboardLayoutCheckoutImport.update({
    path: '/checkout',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)

const AppAuthDashboardLayoutCalendarRoute =
  AppAuthDashboardLayoutCalendarImport.update({
    path: '/calendar',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)

const AppAuthDashboardLayoutAutomationsRoute =
  AppAuthDashboardLayoutAutomationsImport.update({
    path: '/automations',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)

const AppAuthDashboardLayoutAgentRoute =
  AppAuthDashboardLayoutAgentImport.update({
    path: '/agent',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)

const AppAuthAdminLayoutUsersRoute = AppAuthAdminLayoutUsersImport.update({
  path: '/users',
  getParentRoute: () => AppAuthAdminLayoutRoute,
} as any)

const AppAuthAdminLayoutReductoRoute = AppAuthAdminLayoutReductoImport.update({
  path: '/reducto',
  getParentRoute: () => AppAuthAdminLayoutRoute,
} as any)

const AppAuthAdminLayoutOrganisationsRoute =
  AppAuthAdminLayoutOrganisationsImport.update({
    path: '/organisations',
    getParentRoute: () => AppAuthAdminLayoutRoute,
  } as any)

const AppAuthAdminLayoutMasterLibraryRoute =
  AppAuthAdminLayoutMasterLibraryImport.update({
    path: '/master-library',
    getParentRoute: () => AppAuthAdminLayoutRoute,
  } as any)

const AppAuthAdminLayoutInvitationsRoute =
  AppAuthAdminLayoutInvitationsImport.update({
    path: '/invitations',
    getParentRoute: () => AppAuthAdminLayoutRoute,
  } as any)

const AppAuthAdminLayoutInfotrackRoute =
  AppAuthAdminLayoutInfotrackImport.update({
    path: '/infotrack',
    getParentRoute: () => AppAuthAdminLayoutRoute,
  } as any)

const AppAuthAdminLayoutEmailTemplatesRoute =
  AppAuthAdminLayoutEmailTemplatesImport.update({
    path: '/email-templates',
    getParentRoute: () => AppAuthAdminLayoutRoute,
  } as any)

const AppAuthAdminLayoutCostManagementRoute =
  AppAuthAdminLayoutCostManagementImport.update({
    path: '/cost-management',
    getParentRoute: () => AppAuthAdminLayoutRoute,
  } as any)

const AppAuthAdminLayoutBillingRoute = AppAuthAdminLayoutBillingImport.update({
  path: '/billing',
  getParentRoute: () => AppAuthAdminLayoutRoute,
} as any)

const AppAuthAdminLayoutAiUsageRoute = AppAuthAdminLayoutAiUsageImport.update({
  path: '/ai-usage',
  getParentRoute: () => AppAuthAdminLayoutRoute,
} as any)

const AppAuthDashboardLayoutWorkflowsIndexRoute =
  AppAuthDashboardLayoutWorkflowsIndexImport.update({
    path: '/',
    getParentRoute: () => AppAuthDashboardLayoutWorkflowsRoute,
  } as any)

const AppAuthDashboardLayoutSettingsIndexRoute =
  AppAuthDashboardLayoutSettingsIndexImport.update({
    path: '/',
    getParentRoute: () => AppAuthDashboardLayoutSettingsRoute,
  } as any)

const AppAuthDashboardLayoutJobsIndexRoute =
  AppAuthDashboardLayoutJobsIndexImport.update({
    path: '/',
    getParentRoute: () => AppAuthDashboardLayoutJobsRoute,
  } as any)

const AppAuthDashboardLayoutFirmContactsIndexRoute =
  AppAuthDashboardLayoutFirmContactsIndexImport.update({
    path: '/',
    getParentRoute: () => AppAuthDashboardLayoutFirmContactsRoute,
  } as any)

const AppAuthDashboardLayoutWorkflowsWorkflowIdRoute =
  AppAuthDashboardLayoutWorkflowsWorkflowIdImport.update({
    path: '/$workflowId',
    getParentRoute: () => AppAuthDashboardLayoutWorkflowsRoute,
  } as any)

const AppAuthDashboardLayoutSettingsSnippetsRoute =
  AppAuthDashboardLayoutSettingsSnippetsImport.update({
    path: '/snippets',
    getParentRoute: () => AppAuthDashboardLayoutSettingsRoute,
  } as any)

const AppAuthDashboardLayoutSettingsReportTemplatesRoute =
  AppAuthDashboardLayoutSettingsReportTemplatesImport.update({
    path: '/report-templates',
    getParentRoute: () => AppAuthDashboardLayoutSettingsRoute,
  } as any)

const AppAuthDashboardLayoutSettingsPublicHolidaysRoute =
  AppAuthDashboardLayoutSettingsPublicHolidaysImport.update({
    path: '/public-holidays',
    getParentRoute: () => AppAuthDashboardLayoutSettingsRoute,
  } as any)

const AppAuthDashboardLayoutSettingsOrganizationRoute =
  AppAuthDashboardLayoutSettingsOrganizationImport.update({
    path: '/organization',
    getParentRoute: () => AppAuthDashboardLayoutSettingsRoute,
  } as any)

const AppAuthDashboardLayoutSettingsJobcodeRoute =
  AppAuthDashboardLayoutSettingsJobcodeImport.update({
    path: '/jobcode',
    getParentRoute: () => AppAuthDashboardLayoutSettingsRoute,
  } as any)

const AppAuthDashboardLayoutSettingsIntegrationsRoute =
  AppAuthDashboardLayoutSettingsIntegrationsImport.update({
    path: '/integrations',
    getParentRoute: () => AppAuthDashboardLayoutSettingsRoute,
  } as any)

const AppAuthDashboardLayoutSettingsHelpRoute =
  AppAuthDashboardLayoutSettingsHelpImport.update({
    path: '/help',
    getParentRoute: () => AppAuthDashboardLayoutSettingsRoute,
  } as any)

const AppAuthDashboardLayoutSettingsFieldsRoute =
  AppAuthDashboardLayoutSettingsFieldsImport.update({
    path: '/fields',
    getParentRoute: () => AppAuthDashboardLayoutSettingsRoute,
  } as any)

const AppAuthDashboardLayoutSettingsDocsRoute =
  AppAuthDashboardLayoutSettingsDocsImport.update({
    path: '/docs',
    getParentRoute: () => AppAuthDashboardLayoutSettingsRoute,
  } as any)

const AppAuthDashboardLayoutSettingsContactRolesRoute =
  AppAuthDashboardLayoutSettingsContactRolesImport.update({
    path: '/contact-roles',
    getParentRoute: () => AppAuthDashboardLayoutSettingsRoute,
  } as any)

const AppAuthDashboardLayoutSettingsBrandingRoute =
  AppAuthDashboardLayoutSettingsBrandingImport.update({
    path: '/branding',
    getParentRoute: () => AppAuthDashboardLayoutSettingsRoute,
  } as any)

const AppAuthDashboardLayoutSettingsBillingRoute =
  AppAuthDashboardLayoutSettingsBillingImport.update({
    path: '/billing',
    getParentRoute: () => AppAuthDashboardLayoutSettingsRoute,
  } as any)

const AppAuthDashboardLayoutJobsJobIdRoute =
  AppAuthDashboardLayoutJobsJobIdImport.update({
    path: '/$jobId',
    getParentRoute: () => AppAuthDashboardLayoutJobsRoute,
  } as any)

const AppAuthDashboardLayoutFirmContactsFieldsRoute =
  AppAuthDashboardLayoutFirmContactsFieldsImport.update({
    path: '/fields',
    getParentRoute: () => AppAuthDashboardLayoutFirmContactsRoute,
  } as any)

const AppAuthDashboardLayoutFirmContactsCategoriesRoute =
  AppAuthDashboardLayoutFirmContactsCategoriesImport.update({
    path: '/categories',
    getParentRoute: () => AppAuthDashboardLayoutFirmContactsRoute,
  } as any)

const AppAuthAdminLayoutUsersUserIdRoute =
  AppAuthAdminLayoutUsersUserIdImport.update({
    path: '/$userId',
    getParentRoute: () => AppAuthAdminLayoutUsersRoute,
  } as any)

const AppAuthAdminLayoutOrganisationsOrgIdRoute =
  AppAuthAdminLayoutOrganisationsOrgIdImport.update({
    path: '/$orgId',
    getParentRoute: () => AppAuthAdminLayoutOrganisationsRoute,
  } as any)

const AppAuthDashboardLayoutJobsJobIdIndexRoute =
  AppAuthDashboardLayoutJobsJobIdIndexImport.update({
    path: '/',
    getParentRoute: () => AppAuthDashboardLayoutJobsJobIdRoute,
  } as any)

const AppAuthDashboardLayoutJobsJobIdTimesheetsRoute =
  AppAuthDashboardLayoutJobsJobIdTimesheetsImport.update({
    path: '/timesheets',
    getParentRoute: () => AppAuthDashboardLayoutJobsJobIdRoute,
  } as any)

const AppAuthDashboardLayoutJobsJobIdSummariesRoute =
  AppAuthDashboardLayoutJobsJobIdSummariesImport.update({
    path: '/summaries',
    getParentRoute: () => AppAuthDashboardLayoutJobsJobIdRoute,
  } as any)

const AppAuthDashboardLayoutJobsJobIdSettingsRoute =
  AppAuthDashboardLayoutJobsJobIdSettingsImport.update({
    path: '/settings',
    getParentRoute: () => AppAuthDashboardLayoutJobsJobIdRoute,
  } as any)

const AppAuthDashboardLayoutJobsJobIdSearchesRoute =
  AppAuthDashboardLayoutJobsJobIdSearchesImport.update({
    path: '/searches',
    getParentRoute: () => AppAuthDashboardLayoutJobsJobIdRoute,
  } as any)

const AppAuthDashboardLayoutJobsJobIdReviewRoute =
  AppAuthDashboardLayoutJobsJobIdReviewImport.update({
    path: '/review',
    getParentRoute: () => AppAuthDashboardLayoutJobsJobIdRoute,
  } as any)

const AppAuthDashboardLayoutJobsJobIdReportingRoute =
  AppAuthDashboardLayoutJobsJobIdReportingImport.update({
    path: '/reporting',
    getParentRoute: () => AppAuthDashboardLayoutJobsJobIdRoute,
  } as any)

const AppAuthDashboardLayoutJobsJobIdRecoveriesRoute =
  AppAuthDashboardLayoutJobsJobIdRecoveriesImport.update({
    path: '/recoveries',
    getParentRoute: () => AppAuthDashboardLayoutJobsJobIdRoute,
  } as any)

const AppAuthDashboardLayoutJobsJobIdPlanRoute =
  AppAuthDashboardLayoutJobsJobIdPlanImport.update({
    path: '/plan',
    getParentRoute: () => AppAuthDashboardLayoutJobsJobIdRoute,
  } as any)

const AppAuthDashboardLayoutJobsJobIdMailRoute =
  AppAuthDashboardLayoutJobsJobIdMailImport.update({
    path: '/mail',
    getParentRoute: () => AppAuthDashboardLayoutJobsJobIdRoute,
  } as any)

const AppAuthDashboardLayoutJobsJobIdGeneratePrecedentsRoute =
  AppAuthDashboardLayoutJobsJobIdGeneratePrecedentsImport.update({
    path: '/generate-precedents',
    getParentRoute: () => AppAuthDashboardLayoutJobsJobIdRoute,
  } as any)

const AppAuthDashboardLayoutJobsJobIdGatherInformationRoute =
  AppAuthDashboardLayoutJobsJobIdGatherInformationImport.update({
    path: '/gather-information',
    getParentRoute: () => AppAuthDashboardLayoutJobsJobIdRoute,
  } as any)

const AppAuthDashboardLayoutJobsJobIdGatherRoute =
  AppAuthDashboardLayoutJobsJobIdGatherImport.update({
    path: '/gather',
    getParentRoute: () => AppAuthDashboardLayoutJobsJobIdRoute,
  } as any)

const AppAuthDashboardLayoutJobsJobIdDayOneRoute =
  AppAuthDashboardLayoutJobsJobIdDayOneImport.update({
    path: '/day-one',
    getParentRoute: () => AppAuthDashboardLayoutJobsJobIdRoute,
  } as any)

const AppAuthDashboardLayoutJobsJobIdContactsRoute =
  AppAuthDashboardLayoutJobsJobIdContactsImport.update({
    path: '/contacts',
    getParentRoute: () => AppAuthDashboardLayoutJobsJobIdRoute,
  } as any)

const AppAuthDashboardLayoutJobsJobIdCalendarRoute =
  AppAuthDashboardLayoutJobsJobIdCalendarImport.update({
    path: '/calendar',
    getParentRoute: () => AppAuthDashboardLayoutJobsJobIdRoute,
  } as any)

const AppAuthDashboardLayoutJobsJobIdAgentRoute =
  AppAuthDashboardLayoutJobsJobIdAgentImport.update({
    path: '/agent',
    getParentRoute: () => AppAuthDashboardLayoutJobsJobIdRoute,
  } as any)

const AppAuthDashboardLayoutJobsJobIdSummariesIndexRoute =
  AppAuthDashboardLayoutJobsJobIdSummariesIndexImport.update({
    path: '/',
    getParentRoute: () => AppAuthDashboardLayoutJobsJobIdSummariesRoute,
  } as any)

const AppAuthDashboardLayoutJobsJobIdSearchesIndexRoute =
  AppAuthDashboardLayoutJobsJobIdSearchesIndexImport.update({
    path: '/',
    getParentRoute: () => AppAuthDashboardLayoutJobsJobIdSearchesRoute,
  } as any)

const AppAuthDashboardLayoutJobsJobIdReviewIndexRoute =
  AppAuthDashboardLayoutJobsJobIdReviewIndexImport.update({
    path: '/',
    getParentRoute: () => AppAuthDashboardLayoutJobsJobIdReviewRoute,
  } as any)

const AppAuthDashboardLayoutJobsJobIdRecoveriesIndexRoute =
  AppAuthDashboardLayoutJobsJobIdRecoveriesIndexImport.update({
    path: '/',
    getParentRoute: () => AppAuthDashboardLayoutJobsJobIdRecoveriesRoute,
  } as any)

const AppAuthDashboardLayoutJobsJobIdGatherIndexRoute =
  AppAuthDashboardLayoutJobsJobIdGatherIndexImport.update({
    path: '/',
    getParentRoute: () => AppAuthDashboardLayoutJobsJobIdGatherRoute,
  } as any)

const AppAuthDashboardLayoutJobsJobIdCalendarIndexRoute =
  AppAuthDashboardLayoutJobsJobIdCalendarIndexImport.update({
    path: '/',
    getParentRoute: () => AppAuthDashboardLayoutJobsJobIdCalendarRoute,
  } as any)

const AppAuthDashboardLayoutJobsJobIdSummariesAgentRoute =
  AppAuthDashboardLayoutJobsJobIdSummariesAgentImport.update({
    path: '/$agent',
    getParentRoute: () => AppAuthDashboardLayoutJobsJobIdSummariesRoute,
  } as any)

const AppAuthDashboardLayoutJobsJobIdSearchesWebRoute =
  AppAuthDashboardLayoutJobsJobIdSearchesWebImport.update({
    path: '/web',
    getParentRoute: () => AppAuthDashboardLayoutJobsJobIdSearchesRoute,
  } as any)

const AppAuthDashboardLayoutJobsJobIdSearchesKycAmlRoute =
  AppAuthDashboardLayoutJobsJobIdSearchesKycAmlImport.update({
    path: '/kyc-aml',
    getParentRoute: () => AppAuthDashboardLayoutJobsJobIdSearchesRoute,
  } as any)

const AppAuthDashboardLayoutJobsJobIdSearchesInfotrackRoute =
  AppAuthDashboardLayoutJobsJobIdSearchesInfotrackImport.update({
    path: '/infotrack',
    getParentRoute: () => AppAuthDashboardLayoutJobsJobIdSearchesRoute,
  } as any)

const AppAuthDashboardLayoutJobsJobIdReviewAgentRoute =
  AppAuthDashboardLayoutJobsJobIdReviewAgentImport.update({
    path: '/$agent',
    getParentRoute: () => AppAuthDashboardLayoutJobsJobIdReviewRoute,
  } as any)

const AppAuthDashboardLayoutJobsJobIdRecoveriesSectionRoute =
  AppAuthDashboardLayoutJobsJobIdRecoveriesSectionImport.update({
    path: '/$section',
    getParentRoute: () => AppAuthDashboardLayoutJobsJobIdRecoveriesRoute,
  } as any)

const AppAuthDashboardLayoutJobsJobIdCalendarTasksRoute =
  AppAuthDashboardLayoutJobsJobIdCalendarTasksImport.update({
    path: '/tasks',
    getParentRoute: () => AppAuthDashboardLayoutJobsJobIdCalendarRoute,
  } as any)

const AppAuthDashboardLayoutJobsJobIdCalendarReviewWindowsRoute =
  AppAuthDashboardLayoutJobsJobIdCalendarReviewWindowsImport.update({
    path: '/review-windows',
    getParentRoute: () => AppAuthDashboardLayoutJobsJobIdCalendarRoute,
  } as any)

const AppAuthDashboardLayoutJobsJobIdCalendarOverviewRoute =
  AppAuthDashboardLayoutJobsJobIdCalendarOverviewImport.update({
    path: '/overview',
    getParentRoute: () => AppAuthDashboardLayoutJobsJobIdCalendarRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppImport
      parentRoute: typeof rootRoute
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactImport
      parentRoute: typeof rootRoute
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyImport
      parentRoute: typeof rootRoute
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsImport
      parentRoute: typeof rootRoute
    }
    '/_app/_auth': {
      id: '/_app/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppAuthImport
      parentRoute: typeof AppImport
    }
    '/_app/_dev': {
      id: '/_app/_dev'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppDevImport
      parentRoute: typeof AppImport
    }
    '/conflict-check/$token': {
      id: '/conflict-check/$token'
      path: '/conflict-check/$token'
      fullPath: '/conflict-check/$token'
      preLoaderRoute: typeof ConflictCheckTokenImport
      parentRoute: typeof rootRoute
    }
    '/_app/_dev/component-library': {
      id: '/_app/_dev/component-library'
      path: '/component-library'
      fullPath: '/component-library'
      preLoaderRoute: typeof AppDevComponentLibraryImport
      parentRoute: typeof AppDevImport
    }
    '/_app/login': {
      id: '/_app/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AppLoginImport
      parentRoute: typeof AppImport
    }
    '/_app/login/_layout': {
      id: '/_app/login/_layout'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AppLoginLayoutImport
      parentRoute: typeof AppLoginRoute
    }
    '/_app/_auth/admin': {
      id: '/_app/_auth/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAuthAdminImport
      parentRoute: typeof AppAuthImport
    }
    '/_app/_auth/admin/_layout': {
      id: '/_app/_auth/admin/_layout'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAuthAdminLayoutImport
      parentRoute: typeof AppAuthAdminRoute
    }
    '/_app/_auth/dashboard': {
      id: '/_app/_auth/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppAuthDashboardImport
      parentRoute: typeof AppAuthImport
    }
    '/_app/_auth/dashboard/_layout': {
      id: '/_app/_auth/dashboard/_layout'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppAuthDashboardLayoutImport
      parentRoute: typeof AppAuthDashboardRoute
    }
    '/_app/_auth/onboarding': {
      id: '/_app/_auth/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AppAuthOnboardingImport
      parentRoute: typeof AppAuthImport
    }
    '/_app/_auth/onboarding/_layout': {
      id: '/_app/_auth/onboarding/_layout'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AppAuthOnboardingLayoutImport
      parentRoute: typeof AppAuthOnboardingRoute
    }
    '/_app/login/_layout/': {
      id: '/_app/login/_layout/'
      path: '/'
      fullPath: '/login/'
      preLoaderRoute: typeof AppLoginLayoutIndexImport
      parentRoute: typeof AppLoginLayoutImport
    }
    '/_app/_auth/admin/_layout/ai-usage': {
      id: '/_app/_auth/admin/_layout/ai-usage'
      path: '/ai-usage'
      fullPath: '/admin/ai-usage'
      preLoaderRoute: typeof AppAuthAdminLayoutAiUsageImport
      parentRoute: typeof AppAuthAdminLayoutImport
    }
    '/_app/_auth/admin/_layout/billing': {
      id: '/_app/_auth/admin/_layout/billing'
      path: '/billing'
      fullPath: '/admin/billing'
      preLoaderRoute: typeof AppAuthAdminLayoutBillingImport
      parentRoute: typeof AppAuthAdminLayoutImport
    }
    '/_app/_auth/admin/_layout/cost-management': {
      id: '/_app/_auth/admin/_layout/cost-management'
      path: '/cost-management'
      fullPath: '/admin/cost-management'
      preLoaderRoute: typeof AppAuthAdminLayoutCostManagementImport
      parentRoute: typeof AppAuthAdminLayoutImport
    }
    '/_app/_auth/admin/_layout/email-templates': {
      id: '/_app/_auth/admin/_layout/email-templates'
      path: '/email-templates'
      fullPath: '/admin/email-templates'
      preLoaderRoute: typeof AppAuthAdminLayoutEmailTemplatesImport
      parentRoute: typeof AppAuthAdminLayoutImport
    }
    '/_app/_auth/admin/_layout/infotrack': {
      id: '/_app/_auth/admin/_layout/infotrack'
      path: '/infotrack'
      fullPath: '/admin/infotrack'
      preLoaderRoute: typeof AppAuthAdminLayoutInfotrackImport
      parentRoute: typeof AppAuthAdminLayoutImport
    }
    '/_app/_auth/admin/_layout/invitations': {
      id: '/_app/_auth/admin/_layout/invitations'
      path: '/invitations'
      fullPath: '/admin/invitations'
      preLoaderRoute: typeof AppAuthAdminLayoutInvitationsImport
      parentRoute: typeof AppAuthAdminLayoutImport
    }
    '/_app/_auth/admin/_layout/master-library': {
      id: '/_app/_auth/admin/_layout/master-library'
      path: '/master-library'
      fullPath: '/admin/master-library'
      preLoaderRoute: typeof AppAuthAdminLayoutMasterLibraryImport
      parentRoute: typeof AppAuthAdminLayoutImport
    }
    '/_app/_auth/admin/_layout/organisations': {
      id: '/_app/_auth/admin/_layout/organisations'
      path: '/organisations'
      fullPath: '/admin/organisations'
      preLoaderRoute: typeof AppAuthAdminLayoutOrganisationsImport
      parentRoute: typeof AppAuthAdminLayoutImport
    }
    '/_app/_auth/admin/_layout/reducto': {
      id: '/_app/_auth/admin/_layout/reducto'
      path: '/reducto'
      fullPath: '/admin/reducto'
      preLoaderRoute: typeof AppAuthAdminLayoutReductoImport
      parentRoute: typeof AppAuthAdminLayoutImport
    }
    '/_app/_auth/admin/_layout/users': {
      id: '/_app/_auth/admin/_layout/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AppAuthAdminLayoutUsersImport
      parentRoute: typeof AppAuthAdminLayoutImport
    }
    '/_app/_auth/dashboard/_layout/agent': {
      id: '/_app/_auth/dashboard/_layout/agent'
      path: '/agent'
      fullPath: '/dashboard/agent'
      preLoaderRoute: typeof AppAuthDashboardLayoutAgentImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/dashboard/_layout/automations': {
      id: '/_app/_auth/dashboard/_layout/automations'
      path: '/automations'
      fullPath: '/dashboard/automations'
      preLoaderRoute: typeof AppAuthDashboardLayoutAutomationsImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/dashboard/_layout/calendar': {
      id: '/_app/_auth/dashboard/_layout/calendar'
      path: '/calendar'
      fullPath: '/dashboard/calendar'
      preLoaderRoute: typeof AppAuthDashboardLayoutCalendarImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/dashboard/_layout/checkout': {
      id: '/_app/_auth/dashboard/_layout/checkout'
      path: '/checkout'
      fullPath: '/dashboard/checkout'
      preLoaderRoute: typeof AppAuthDashboardLayoutCheckoutImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/dashboard/_layout/firm-contacts': {
      id: '/_app/_auth/dashboard/_layout/firm-contacts'
      path: '/firm-contacts'
      fullPath: '/dashboard/firm-contacts'
      preLoaderRoute: typeof AppAuthDashboardLayoutFirmContactsImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/dashboard/_layout/inbox': {
      id: '/_app/_auth/dashboard/_layout/inbox'
      path: '/inbox'
      fullPath: '/dashboard/inbox'
      preLoaderRoute: typeof AppAuthDashboardLayoutInboxImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/dashboard/_layout/jobs': {
      id: '/_app/_auth/dashboard/_layout/jobs'
      path: '/jobs'
      fullPath: '/dashboard/jobs'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/dashboard/_layout/mail': {
      id: '/_app/_auth/dashboard/_layout/mail'
      path: '/mail'
      fullPath: '/dashboard/mail'
      preLoaderRoute: typeof AppAuthDashboardLayoutMailImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/dashboard/_layout/my-tasks': {
      id: '/_app/_auth/dashboard/_layout/my-tasks'
      path: '/my-tasks'
      fullPath: '/dashboard/my-tasks'
      preLoaderRoute: typeof AppAuthDashboardLayoutMyTasksImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/dashboard/_layout/pre-appointment': {
      id: '/_app/_auth/dashboard/_layout/pre-appointment'
      path: '/pre-appointment'
      fullPath: '/dashboard/pre-appointment'
      preLoaderRoute: typeof AppAuthDashboardLayoutPreAppointmentImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/dashboard/_layout/pre-appointment-fields': {
      id: '/_app/_auth/dashboard/_layout/pre-appointment-fields'
      path: '/pre-appointment-fields'
      fullPath: '/dashboard/pre-appointment-fields'
      preLoaderRoute: typeof AppAuthDashboardLayoutPreAppointmentFieldsImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/dashboard/_layout/pre-appointment-labels': {
      id: '/_app/_auth/dashboard/_layout/pre-appointment-labels'
      path: '/pre-appointment-labels'
      fullPath: '/dashboard/pre-appointment-labels'
      preLoaderRoute: typeof AppAuthDashboardLayoutPreAppointmentLabelsImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/dashboard/_layout/pre-appointment-settings': {
      id: '/_app/_auth/dashboard/_layout/pre-appointment-settings'
      path: '/pre-appointment-settings'
      fullPath: '/dashboard/pre-appointment-settings'
      preLoaderRoute: typeof AppAuthDashboardLayoutPreAppointmentSettingsImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/dashboard/_layout/pre-appointment-statuses': {
      id: '/_app/_auth/dashboard/_layout/pre-appointment-statuses'
      path: '/pre-appointment-statuses'
      fullPath: '/dashboard/pre-appointment-statuses'
      preLoaderRoute: typeof AppAuthDashboardLayoutPreAppointmentStatusesImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/dashboard/_layout/settings': {
      id: '/_app/_auth/dashboard/_layout/settings'
      path: '/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof AppAuthDashboardLayoutSettingsImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/dashboard/_layout/task-labels': {
      id: '/_app/_auth/dashboard/_layout/task-labels'
      path: '/task-labels'
      fullPath: '/dashboard/task-labels'
      preLoaderRoute: typeof AppAuthDashboardLayoutTaskLabelsImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/dashboard/_layout/task-statuses': {
      id: '/_app/_auth/dashboard/_layout/task-statuses'
      path: '/task-statuses'
      fullPath: '/dashboard/task-statuses'
      preLoaderRoute: typeof AppAuthDashboardLayoutTaskStatusesImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/dashboard/_layout/timesheet-approvals': {
      id: '/_app/_auth/dashboard/_layout/timesheet-approvals'
      path: '/timesheet-approvals'
      fullPath: '/dashboard/timesheet-approvals'
      preLoaderRoute: typeof AppAuthDashboardLayoutTimesheetApprovalsImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/dashboard/_layout/timesheet-reports': {
      id: '/_app/_auth/dashboard/_layout/timesheet-reports'
      path: '/timesheet-reports'
      fullPath: '/dashboard/timesheet-reports'
      preLoaderRoute: typeof AppAuthDashboardLayoutTimesheetReportsImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/dashboard/_layout/timesheet-settings': {
      id: '/_app/_auth/dashboard/_layout/timesheet-settings'
      path: '/timesheet-settings'
      fullPath: '/dashboard/timesheet-settings'
      preLoaderRoute: typeof AppAuthDashboardLayoutTimesheetSettingsImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/dashboard/_layout/timesheets': {
      id: '/_app/_auth/dashboard/_layout/timesheets'
      path: '/timesheets'
      fullPath: '/dashboard/timesheets'
      preLoaderRoute: typeof AppAuthDashboardLayoutTimesheetsImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/dashboard/_layout/workflow-roles': {
      id: '/_app/_auth/dashboard/_layout/workflow-roles'
      path: '/workflow-roles'
      fullPath: '/dashboard/workflow-roles'
      preLoaderRoute: typeof AppAuthDashboardLayoutWorkflowRolesImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/dashboard/_layout/workflows': {
      id: '/_app/_auth/dashboard/_layout/workflows'
      path: '/workflows'
      fullPath: '/dashboard/workflows'
      preLoaderRoute: typeof AppAuthDashboardLayoutWorkflowsImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/onboarding/_layout/organization': {
      id: '/_app/_auth/onboarding/_layout/organization'
      path: '/organization'
      fullPath: '/onboarding/organization'
      preLoaderRoute: typeof AppAuthOnboardingLayoutOrganizationImport
      parentRoute: typeof AppAuthOnboardingLayoutImport
    }
    '/_app/_auth/admin/_layout/': {
      id: '/_app/_auth/admin/_layout/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AppAuthAdminLayoutIndexImport
      parentRoute: typeof AppAuthAdminLayoutImport
    }
    '/_app/_auth/dashboard/_layout/': {
      id: '/_app/_auth/dashboard/_layout/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AppAuthDashboardLayoutIndexImport
      parentRoute: typeof AppAuthDashboardLayoutImport
    }
    '/_app/_auth/admin/_layout/organisations/$orgId': {
      id: '/_app/_auth/admin/_layout/organisations/$orgId'
      path: '/$orgId'
      fullPath: '/admin/organisations/$orgId'
      preLoaderRoute: typeof AppAuthAdminLayoutOrganisationsOrgIdImport
      parentRoute: typeof AppAuthAdminLayoutOrganisationsImport
    }
    '/_app/_auth/admin/_layout/users/$userId': {
      id: '/_app/_auth/admin/_layout/users/$userId'
      path: '/$userId'
      fullPath: '/admin/users/$userId'
      preLoaderRoute: typeof AppAuthAdminLayoutUsersUserIdImport
      parentRoute: typeof AppAuthAdminLayoutUsersImport
    }
    '/_app/_auth/dashboard/_layout/firm-contacts/categories': {
      id: '/_app/_auth/dashboard/_layout/firm-contacts/categories'
      path: '/categories'
      fullPath: '/dashboard/firm-contacts/categories'
      preLoaderRoute: typeof AppAuthDashboardLayoutFirmContactsCategoriesImport
      parentRoute: typeof AppAuthDashboardLayoutFirmContactsImport
    }
    '/_app/_auth/dashboard/_layout/firm-contacts/fields': {
      id: '/_app/_auth/dashboard/_layout/firm-contacts/fields'
      path: '/fields'
      fullPath: '/dashboard/firm-contacts/fields'
      preLoaderRoute: typeof AppAuthDashboardLayoutFirmContactsFieldsImport
      parentRoute: typeof AppAuthDashboardLayoutFirmContactsImport
    }
    '/_app/_auth/dashboard/_layout/jobs/$jobId': {
      id: '/_app/_auth/dashboard/_layout/jobs/$jobId'
      path: '/$jobId'
      fullPath: '/dashboard/jobs/$jobId'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsJobIdImport
      parentRoute: typeof AppAuthDashboardLayoutJobsImport
    }
    '/_app/_auth/dashboard/_layout/settings/billing': {
      id: '/_app/_auth/dashboard/_layout/settings/billing'
      path: '/billing'
      fullPath: '/dashboard/settings/billing'
      preLoaderRoute: typeof AppAuthDashboardLayoutSettingsBillingImport
      parentRoute: typeof AppAuthDashboardLayoutSettingsImport
    }
    '/_app/_auth/dashboard/_layout/settings/branding': {
      id: '/_app/_auth/dashboard/_layout/settings/branding'
      path: '/branding'
      fullPath: '/dashboard/settings/branding'
      preLoaderRoute: typeof AppAuthDashboardLayoutSettingsBrandingImport
      parentRoute: typeof AppAuthDashboardLayoutSettingsImport
    }
    '/_app/_auth/dashboard/_layout/settings/contact-roles': {
      id: '/_app/_auth/dashboard/_layout/settings/contact-roles'
      path: '/contact-roles'
      fullPath: '/dashboard/settings/contact-roles'
      preLoaderRoute: typeof AppAuthDashboardLayoutSettingsContactRolesImport
      parentRoute: typeof AppAuthDashboardLayoutSettingsImport
    }
    '/_app/_auth/dashboard/_layout/settings/docs': {
      id: '/_app/_auth/dashboard/_layout/settings/docs'
      path: '/docs'
      fullPath: '/dashboard/settings/docs'
      preLoaderRoute: typeof AppAuthDashboardLayoutSettingsDocsImport
      parentRoute: typeof AppAuthDashboardLayoutSettingsImport
    }
    '/_app/_auth/dashboard/_layout/settings/fields': {
      id: '/_app/_auth/dashboard/_layout/settings/fields'
      path: '/fields'
      fullPath: '/dashboard/settings/fields'
      preLoaderRoute: typeof AppAuthDashboardLayoutSettingsFieldsImport
      parentRoute: typeof AppAuthDashboardLayoutSettingsImport
    }
    '/_app/_auth/dashboard/_layout/settings/help': {
      id: '/_app/_auth/dashboard/_layout/settings/help'
      path: '/help'
      fullPath: '/dashboard/settings/help'
      preLoaderRoute: typeof AppAuthDashboardLayoutSettingsHelpImport
      parentRoute: typeof AppAuthDashboardLayoutSettingsImport
    }
    '/_app/_auth/dashboard/_layout/settings/integrations': {
      id: '/_app/_auth/dashboard/_layout/settings/integrations'
      path: '/integrations'
      fullPath: '/dashboard/settings/integrations'
      preLoaderRoute: typeof AppAuthDashboardLayoutSettingsIntegrationsImport
      parentRoute: typeof AppAuthDashboardLayoutSettingsImport
    }
    '/_app/_auth/dashboard/_layout/settings/jobcode': {
      id: '/_app/_auth/dashboard/_layout/settings/jobcode'
      path: '/jobcode'
      fullPath: '/dashboard/settings/jobcode'
      preLoaderRoute: typeof AppAuthDashboardLayoutSettingsJobcodeImport
      parentRoute: typeof AppAuthDashboardLayoutSettingsImport
    }
    '/_app/_auth/dashboard/_layout/settings/organization': {
      id: '/_app/_auth/dashboard/_layout/settings/organization'
      path: '/organization'
      fullPath: '/dashboard/settings/organization'
      preLoaderRoute: typeof AppAuthDashboardLayoutSettingsOrganizationImport
      parentRoute: typeof AppAuthDashboardLayoutSettingsImport
    }
    '/_app/_auth/dashboard/_layout/settings/public-holidays': {
      id: '/_app/_auth/dashboard/_layout/settings/public-holidays'
      path: '/public-holidays'
      fullPath: '/dashboard/settings/public-holidays'
      preLoaderRoute: typeof AppAuthDashboardLayoutSettingsPublicHolidaysImport
      parentRoute: typeof AppAuthDashboardLayoutSettingsImport
    }
    '/_app/_auth/dashboard/_layout/settings/report-templates': {
      id: '/_app/_auth/dashboard/_layout/settings/report-templates'
      path: '/report-templates'
      fullPath: '/dashboard/settings/report-templates'
      preLoaderRoute: typeof AppAuthDashboardLayoutSettingsReportTemplatesImport
      parentRoute: typeof AppAuthDashboardLayoutSettingsImport
    }
    '/_app/_auth/dashboard/_layout/settings/snippets': {
      id: '/_app/_auth/dashboard/_layout/settings/snippets'
      path: '/snippets'
      fullPath: '/dashboard/settings/snippets'
      preLoaderRoute: typeof AppAuthDashboardLayoutSettingsSnippetsImport
      parentRoute: typeof AppAuthDashboardLayoutSettingsImport
    }
    '/_app/_auth/dashboard/_layout/workflows/$workflowId': {
      id: '/_app/_auth/dashboard/_layout/workflows/$workflowId'
      path: '/$workflowId'
      fullPath: '/dashboard/workflows/$workflowId'
      preLoaderRoute: typeof AppAuthDashboardLayoutWorkflowsWorkflowIdImport
      parentRoute: typeof AppAuthDashboardLayoutWorkflowsImport
    }
    '/_app/_auth/dashboard/_layout/firm-contacts/': {
      id: '/_app/_auth/dashboard/_layout/firm-contacts/'
      path: '/'
      fullPath: '/dashboard/firm-contacts/'
      preLoaderRoute: typeof AppAuthDashboardLayoutFirmContactsIndexImport
      parentRoute: typeof AppAuthDashboardLayoutFirmContactsImport
    }
    '/_app/_auth/dashboard/_layout/jobs/': {
      id: '/_app/_auth/dashboard/_layout/jobs/'
      path: '/'
      fullPath: '/dashboard/jobs/'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsIndexImport
      parentRoute: typeof AppAuthDashboardLayoutJobsImport
    }
    '/_app/_auth/dashboard/_layout/settings/': {
      id: '/_app/_auth/dashboard/_layout/settings/'
      path: '/'
      fullPath: '/dashboard/settings/'
      preLoaderRoute: typeof AppAuthDashboardLayoutSettingsIndexImport
      parentRoute: typeof AppAuthDashboardLayoutSettingsImport
    }
    '/_app/_auth/dashboard/_layout/workflows/': {
      id: '/_app/_auth/dashboard/_layout/workflows/'
      path: '/'
      fullPath: '/dashboard/workflows/'
      preLoaderRoute: typeof AppAuthDashboardLayoutWorkflowsIndexImport
      parentRoute: typeof AppAuthDashboardLayoutWorkflowsImport
    }
    '/_app/_auth/dashboard/_layout/jobs/$jobId/agent': {
      id: '/_app/_auth/dashboard/_layout/jobs/$jobId/agent'
      path: '/agent'
      fullPath: '/dashboard/jobs/$jobId/agent'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsJobIdAgentImport
      parentRoute: typeof AppAuthDashboardLayoutJobsJobIdImport
    }
    '/_app/_auth/dashboard/_layout/jobs/$jobId/calendar': {
      id: '/_app/_auth/dashboard/_layout/jobs/$jobId/calendar'
      path: '/calendar'
      fullPath: '/dashboard/jobs/$jobId/calendar'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsJobIdCalendarImport
      parentRoute: typeof AppAuthDashboardLayoutJobsJobIdImport
    }
    '/_app/_auth/dashboard/_layout/jobs/$jobId/contacts': {
      id: '/_app/_auth/dashboard/_layout/jobs/$jobId/contacts'
      path: '/contacts'
      fullPath: '/dashboard/jobs/$jobId/contacts'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsJobIdContactsImport
      parentRoute: typeof AppAuthDashboardLayoutJobsJobIdImport
    }
    '/_app/_auth/dashboard/_layout/jobs/$jobId/day-one': {
      id: '/_app/_auth/dashboard/_layout/jobs/$jobId/day-one'
      path: '/day-one'
      fullPath: '/dashboard/jobs/$jobId/day-one'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsJobIdDayOneImport
      parentRoute: typeof AppAuthDashboardLayoutJobsJobIdImport
    }
    '/_app/_auth/dashboard/_layout/jobs/$jobId/gather': {
      id: '/_app/_auth/dashboard/_layout/jobs/$jobId/gather'
      path: '/gather'
      fullPath: '/dashboard/jobs/$jobId/gather'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsJobIdGatherImport
      parentRoute: typeof AppAuthDashboardLayoutJobsJobIdImport
    }
    '/_app/_auth/dashboard/_layout/jobs/$jobId/gather-information': {
      id: '/_app/_auth/dashboard/_layout/jobs/$jobId/gather-information'
      path: '/gather-information'
      fullPath: '/dashboard/jobs/$jobId/gather-information'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsJobIdGatherInformationImport
      parentRoute: typeof AppAuthDashboardLayoutJobsJobIdImport
    }
    '/_app/_auth/dashboard/_layout/jobs/$jobId/generate-precedents': {
      id: '/_app/_auth/dashboard/_layout/jobs/$jobId/generate-precedents'
      path: '/generate-precedents'
      fullPath: '/dashboard/jobs/$jobId/generate-precedents'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsJobIdGeneratePrecedentsImport
      parentRoute: typeof AppAuthDashboardLayoutJobsJobIdImport
    }
    '/_app/_auth/dashboard/_layout/jobs/$jobId/mail': {
      id: '/_app/_auth/dashboard/_layout/jobs/$jobId/mail'
      path: '/mail'
      fullPath: '/dashboard/jobs/$jobId/mail'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsJobIdMailImport
      parentRoute: typeof AppAuthDashboardLayoutJobsJobIdImport
    }
    '/_app/_auth/dashboard/_layout/jobs/$jobId/plan': {
      id: '/_app/_auth/dashboard/_layout/jobs/$jobId/plan'
      path: '/plan'
      fullPath: '/dashboard/jobs/$jobId/plan'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsJobIdPlanImport
      parentRoute: typeof AppAuthDashboardLayoutJobsJobIdImport
    }
    '/_app/_auth/dashboard/_layout/jobs/$jobId/recoveries': {
      id: '/_app/_auth/dashboard/_layout/jobs/$jobId/recoveries'
      path: '/recoveries'
      fullPath: '/dashboard/jobs/$jobId/recoveries'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsJobIdRecoveriesImport
      parentRoute: typeof AppAuthDashboardLayoutJobsJobIdImport
    }
    '/_app/_auth/dashboard/_layout/jobs/$jobId/reporting': {
      id: '/_app/_auth/dashboard/_layout/jobs/$jobId/reporting'
      path: '/reporting'
      fullPath: '/dashboard/jobs/$jobId/reporting'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsJobIdReportingImport
      parentRoute: typeof AppAuthDashboardLayoutJobsJobIdImport
    }
    '/_app/_auth/dashboard/_layout/jobs/$jobId/review': {
      id: '/_app/_auth/dashboard/_layout/jobs/$jobId/review'
      path: '/review'
      fullPath: '/dashboard/jobs/$jobId/review'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsJobIdReviewImport
      parentRoute: typeof AppAuthDashboardLayoutJobsJobIdImport
    }
    '/_app/_auth/dashboard/_layout/jobs/$jobId/searches': {
      id: '/_app/_auth/dashboard/_layout/jobs/$jobId/searches'
      path: '/searches'
      fullPath: '/dashboard/jobs/$jobId/searches'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsJobIdSearchesImport
      parentRoute: typeof AppAuthDashboardLayoutJobsJobIdImport
    }
    '/_app/_auth/dashboard/_layout/jobs/$jobId/settings': {
      id: '/_app/_auth/dashboard/_layout/jobs/$jobId/settings'
      path: '/settings'
      fullPath: '/dashboard/jobs/$jobId/settings'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsJobIdSettingsImport
      parentRoute: typeof AppAuthDashboardLayoutJobsJobIdImport
    }
    '/_app/_auth/dashboard/_layout/jobs/$jobId/summaries': {
      id: '/_app/_auth/dashboard/_layout/jobs/$jobId/summaries'
      path: '/summaries'
      fullPath: '/dashboard/jobs/$jobId/summaries'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsJobIdSummariesImport
      parentRoute: typeof AppAuthDashboardLayoutJobsJobIdImport
    }
    '/_app/_auth/dashboard/_layout/jobs/$jobId/timesheets': {
      id: '/_app/_auth/dashboard/_layout/jobs/$jobId/timesheets'
      path: '/timesheets'
      fullPath: '/dashboard/jobs/$jobId/timesheets'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsJobIdTimesheetsImport
      parentRoute: typeof AppAuthDashboardLayoutJobsJobIdImport
    }
    '/_app/_auth/dashboard/_layout/jobs/$jobId/': {
      id: '/_app/_auth/dashboard/_layout/jobs/$jobId/'
      path: '/'
      fullPath: '/dashboard/jobs/$jobId/'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsJobIdIndexImport
      parentRoute: typeof AppAuthDashboardLayoutJobsJobIdImport
    }
    '/_app/_auth/dashboard/_layout/jobs/$jobId/calendar/overview': {
      id: '/_app/_auth/dashboard/_layout/jobs/$jobId/calendar/overview'
      path: '/overview'
      fullPath: '/dashboard/jobs/$jobId/calendar/overview'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsJobIdCalendarOverviewImport
      parentRoute: typeof AppAuthDashboardLayoutJobsJobIdCalendarImport
    }
    '/_app/_auth/dashboard/_layout/jobs/$jobId/calendar/review-windows': {
      id: '/_app/_auth/dashboard/_layout/jobs/$jobId/calendar/review-windows'
      path: '/review-windows'
      fullPath: '/dashboard/jobs/$jobId/calendar/review-windows'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsJobIdCalendarReviewWindowsImport
      parentRoute: typeof AppAuthDashboardLayoutJobsJobIdCalendarImport
    }
    '/_app/_auth/dashboard/_layout/jobs/$jobId/calendar/tasks': {
      id: '/_app/_auth/dashboard/_layout/jobs/$jobId/calendar/tasks'
      path: '/tasks'
      fullPath: '/dashboard/jobs/$jobId/calendar/tasks'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsJobIdCalendarTasksImport
      parentRoute: typeof AppAuthDashboardLayoutJobsJobIdCalendarImport
    }
    '/_app/_auth/dashboard/_layout/jobs/$jobId/recoveries/$section': {
      id: '/_app/_auth/dashboard/_layout/jobs/$jobId/recoveries/$section'
      path: '/$section'
      fullPath: '/dashboard/jobs/$jobId/recoveries/$section'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsJobIdRecoveriesSectionImport
      parentRoute: typeof AppAuthDashboardLayoutJobsJobIdRecoveriesImport
    }
    '/_app/_auth/dashboard/_layout/jobs/$jobId/review/$agent': {
      id: '/_app/_auth/dashboard/_layout/jobs/$jobId/review/$agent'
      path: '/$agent'
      fullPath: '/dashboard/jobs/$jobId/review/$agent'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsJobIdReviewAgentImport
      parentRoute: typeof AppAuthDashboardLayoutJobsJobIdReviewImport
    }
    '/_app/_auth/dashboard/_layout/jobs/$jobId/searches/infotrack': {
      id: '/_app/_auth/dashboard/_layout/jobs/$jobId/searches/infotrack'
      path: '/infotrack'
      fullPath: '/dashboard/jobs/$jobId/searches/infotrack'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsJobIdSearchesInfotrackImport
      parentRoute: typeof AppAuthDashboardLayoutJobsJobIdSearchesImport
    }
    '/_app/_auth/dashboard/_layout/jobs/$jobId/searches/kyc-aml': {
      id: '/_app/_auth/dashboard/_layout/jobs/$jobId/searches/kyc-aml'
      path: '/kyc-aml'
      fullPath: '/dashboard/jobs/$jobId/searches/kyc-aml'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsJobIdSearchesKycAmlImport
      parentRoute: typeof AppAuthDashboardLayoutJobsJobIdSearchesImport
    }
    '/_app/_auth/dashboard/_layout/jobs/$jobId/searches/web': {
      id: '/_app/_auth/dashboard/_layout/jobs/$jobId/searches/web'
      path: '/web'
      fullPath: '/dashboard/jobs/$jobId/searches/web'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsJobIdSearchesWebImport
      parentRoute: typeof AppAuthDashboardLayoutJobsJobIdSearchesImport
    }
    '/_app/_auth/dashboard/_layout/jobs/$jobId/summaries/$agent': {
      id: '/_app/_auth/dashboard/_layout/jobs/$jobId/summaries/$agent'
      path: '/$agent'
      fullPath: '/dashboard/jobs/$jobId/summaries/$agent'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsJobIdSummariesAgentImport
      parentRoute: typeof AppAuthDashboardLayoutJobsJobIdSummariesImport
    }
    '/_app/_auth/dashboard/_layout/jobs/$jobId/calendar/': {
      id: '/_app/_auth/dashboard/_layout/jobs/$jobId/calendar/'
      path: '/'
      fullPath: '/dashboard/jobs/$jobId/calendar/'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsJobIdCalendarIndexImport
      parentRoute: typeof AppAuthDashboardLayoutJobsJobIdCalendarImport
    }
    '/_app/_auth/dashboard/_layout/jobs/$jobId/gather/': {
      id: '/_app/_auth/dashboard/_layout/jobs/$jobId/gather/'
      path: '/'
      fullPath: '/dashboard/jobs/$jobId/gather/'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsJobIdGatherIndexImport
      parentRoute: typeof AppAuthDashboardLayoutJobsJobIdGatherImport
    }
    '/_app/_auth/dashboard/_layout/jobs/$jobId/recoveries/': {
      id: '/_app/_auth/dashboard/_layout/jobs/$jobId/recoveries/'
      path: '/'
      fullPath: '/dashboard/jobs/$jobId/recoveries/'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsJobIdRecoveriesIndexImport
      parentRoute: typeof AppAuthDashboardLayoutJobsJobIdRecoveriesImport
    }
    '/_app/_auth/dashboard/_layout/jobs/$jobId/review/': {
      id: '/_app/_auth/dashboard/_layout/jobs/$jobId/review/'
      path: '/'
      fullPath: '/dashboard/jobs/$jobId/review/'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsJobIdReviewIndexImport
      parentRoute: typeof AppAuthDashboardLayoutJobsJobIdReviewImport
    }
    '/_app/_auth/dashboard/_layout/jobs/$jobId/searches/': {
      id: '/_app/_auth/dashboard/_layout/jobs/$jobId/searches/'
      path: '/'
      fullPath: '/dashboard/jobs/$jobId/searches/'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsJobIdSearchesIndexImport
      parentRoute: typeof AppAuthDashboardLayoutJobsJobIdSearchesImport
    }
    '/_app/_auth/dashboard/_layout/jobs/$jobId/summaries/': {
      id: '/_app/_auth/dashboard/_layout/jobs/$jobId/summaries/'
      path: '/'
      fullPath: '/dashboard/jobs/$jobId/summaries/'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsJobIdSummariesIndexImport
      parentRoute: typeof AppAuthDashboardLayoutJobsJobIdSummariesImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  IndexRoute,
  AppRoute: AppRoute.addChildren({
    AppAuthRoute: AppAuthRoute.addChildren({
      AppAuthAdminRoute: AppAuthAdminRoute.addChildren({
        AppAuthAdminLayoutRoute: AppAuthAdminLayoutRoute.addChildren({
          AppAuthAdminLayoutAiUsageRoute,
          AppAuthAdminLayoutBillingRoute,
          AppAuthAdminLayoutCostManagementRoute,
          AppAuthAdminLayoutEmailTemplatesRoute,
          AppAuthAdminLayoutInfotrackRoute,
          AppAuthAdminLayoutInvitationsRoute,
          AppAuthAdminLayoutMasterLibraryRoute,
          AppAuthAdminLayoutOrganisationsRoute:
            AppAuthAdminLayoutOrganisationsRoute.addChildren({
              AppAuthAdminLayoutOrganisationsOrgIdRoute,
            }),
          AppAuthAdminLayoutReductoRoute,
          AppAuthAdminLayoutUsersRoute:
            AppAuthAdminLayoutUsersRoute.addChildren({
              AppAuthAdminLayoutUsersUserIdRoute,
            }),
          AppAuthAdminLayoutIndexRoute,
        }),
      }),
      AppAuthDashboardRoute: AppAuthDashboardRoute.addChildren({
        AppAuthDashboardLayoutRoute: AppAuthDashboardLayoutRoute.addChildren({
          AppAuthDashboardLayoutAgentRoute,
          AppAuthDashboardLayoutAutomationsRoute,
          AppAuthDashboardLayoutCalendarRoute,
          AppAuthDashboardLayoutCheckoutRoute,
          AppAuthDashboardLayoutFirmContactsRoute:
            AppAuthDashboardLayoutFirmContactsRoute.addChildren({
              AppAuthDashboardLayoutFirmContactsCategoriesRoute,
              AppAuthDashboardLayoutFirmContactsFieldsRoute,
              AppAuthDashboardLayoutFirmContactsIndexRoute,
            }),
          AppAuthDashboardLayoutInboxRoute,
          AppAuthDashboardLayoutJobsRoute:
            AppAuthDashboardLayoutJobsRoute.addChildren({
              AppAuthDashboardLayoutJobsJobIdRoute:
                AppAuthDashboardLayoutJobsJobIdRoute.addChildren({
                  AppAuthDashboardLayoutJobsJobIdAgentRoute,
                  AppAuthDashboardLayoutJobsJobIdCalendarRoute:
                    AppAuthDashboardLayoutJobsJobIdCalendarRoute.addChildren({
                      AppAuthDashboardLayoutJobsJobIdCalendarOverviewRoute,
                      AppAuthDashboardLayoutJobsJobIdCalendarReviewWindowsRoute,
                      AppAuthDashboardLayoutJobsJobIdCalendarTasksRoute,
                      AppAuthDashboardLayoutJobsJobIdCalendarIndexRoute,
                    }),
                  AppAuthDashboardLayoutJobsJobIdContactsRoute,
                  AppAuthDashboardLayoutJobsJobIdDayOneRoute,
                  AppAuthDashboardLayoutJobsJobIdGatherRoute:
                    AppAuthDashboardLayoutJobsJobIdGatherRoute.addChildren({
                      AppAuthDashboardLayoutJobsJobIdGatherIndexRoute,
                    }),
                  AppAuthDashboardLayoutJobsJobIdGatherInformationRoute,
                  AppAuthDashboardLayoutJobsJobIdGeneratePrecedentsRoute,
                  AppAuthDashboardLayoutJobsJobIdMailRoute,
                  AppAuthDashboardLayoutJobsJobIdPlanRoute,
                  AppAuthDashboardLayoutJobsJobIdRecoveriesRoute:
                    AppAuthDashboardLayoutJobsJobIdRecoveriesRoute.addChildren({
                      AppAuthDashboardLayoutJobsJobIdRecoveriesSectionRoute,
                      AppAuthDashboardLayoutJobsJobIdRecoveriesIndexRoute,
                    }),
                  AppAuthDashboardLayoutJobsJobIdReportingRoute,
                  AppAuthDashboardLayoutJobsJobIdReviewRoute:
                    AppAuthDashboardLayoutJobsJobIdReviewRoute.addChildren({
                      AppAuthDashboardLayoutJobsJobIdReviewAgentRoute,
                      AppAuthDashboardLayoutJobsJobIdReviewIndexRoute,
                    }),
                  AppAuthDashboardLayoutJobsJobIdSearchesRoute:
                    AppAuthDashboardLayoutJobsJobIdSearchesRoute.addChildren({
                      AppAuthDashboardLayoutJobsJobIdSearchesInfotrackRoute,
                      AppAuthDashboardLayoutJobsJobIdSearchesKycAmlRoute,
                      AppAuthDashboardLayoutJobsJobIdSearchesWebRoute,
                      AppAuthDashboardLayoutJobsJobIdSearchesIndexRoute,
                    }),
                  AppAuthDashboardLayoutJobsJobIdSettingsRoute,
                  AppAuthDashboardLayoutJobsJobIdSummariesRoute:
                    AppAuthDashboardLayoutJobsJobIdSummariesRoute.addChildren({
                      AppAuthDashboardLayoutJobsJobIdSummariesAgentRoute,
                      AppAuthDashboardLayoutJobsJobIdSummariesIndexRoute,
                    }),
                  AppAuthDashboardLayoutJobsJobIdTimesheetsRoute,
                  AppAuthDashboardLayoutJobsJobIdIndexRoute,
                }),
              AppAuthDashboardLayoutJobsIndexRoute,
            }),
          AppAuthDashboardLayoutMailRoute,
          AppAuthDashboardLayoutMyTasksRoute,
          AppAuthDashboardLayoutPreAppointmentRoute,
          AppAuthDashboardLayoutPreAppointmentFieldsRoute,
          AppAuthDashboardLayoutPreAppointmentLabelsRoute,
          AppAuthDashboardLayoutPreAppointmentSettingsRoute,
          AppAuthDashboardLayoutPreAppointmentStatusesRoute,
          AppAuthDashboardLayoutSettingsRoute:
            AppAuthDashboardLayoutSettingsRoute.addChildren({
              AppAuthDashboardLayoutSettingsBillingRoute,
              AppAuthDashboardLayoutSettingsBrandingRoute,
              AppAuthDashboardLayoutSettingsContactRolesRoute,
              AppAuthDashboardLayoutSettingsDocsRoute,
              AppAuthDashboardLayoutSettingsFieldsRoute,
              AppAuthDashboardLayoutSettingsHelpRoute,
              AppAuthDashboardLayoutSettingsIntegrationsRoute,
              AppAuthDashboardLayoutSettingsJobcodeRoute,
              AppAuthDashboardLayoutSettingsOrganizationRoute,
              AppAuthDashboardLayoutSettingsPublicHolidaysRoute,
              AppAuthDashboardLayoutSettingsReportTemplatesRoute,
              AppAuthDashboardLayoutSettingsSnippetsRoute,
              AppAuthDashboardLayoutSettingsIndexRoute,
            }),
          AppAuthDashboardLayoutTaskLabelsRoute,
          AppAuthDashboardLayoutTaskStatusesRoute,
          AppAuthDashboardLayoutTimesheetApprovalsRoute,
          AppAuthDashboardLayoutTimesheetReportsRoute,
          AppAuthDashboardLayoutTimesheetSettingsRoute,
          AppAuthDashboardLayoutTimesheetsRoute,
          AppAuthDashboardLayoutWorkflowRolesRoute,
          AppAuthDashboardLayoutWorkflowsRoute:
            AppAuthDashboardLayoutWorkflowsRoute.addChildren({
              AppAuthDashboardLayoutWorkflowsWorkflowIdRoute,
              AppAuthDashboardLayoutWorkflowsIndexRoute,
            }),
          AppAuthDashboardLayoutIndexRoute,
        }),
      }),
      AppAuthOnboardingRoute: AppAuthOnboardingRoute.addChildren({
        AppAuthOnboardingLayoutRoute: AppAuthOnboardingLayoutRoute.addChildren({
          AppAuthOnboardingLayoutOrganizationRoute,
        }),
      }),
    }),
    AppDevRoute: AppDevRoute.addChildren({ AppDevComponentLibraryRoute }),
    AppLoginRoute: AppLoginRoute.addChildren({
      AppLoginLayoutRoute: AppLoginLayoutRoute.addChildren({
        AppLoginLayoutIndexRoute,
      }),
    }),
  }),
  ContactRoute,
  PrivacyRoute,
  TermsRoute,
  ConflictCheckTokenRoute,
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_app",
        "/contact",
        "/privacy",
        "/terms",
        "/conflict-check/$token"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_app": {
      "filePath": "_app.tsx",
      "children": [
        "/_app/_auth",
        "/_app/_dev",
        "/_app/login"
      ]
    },
    "/contact": {
      "filePath": "contact.tsx"
    },
    "/privacy": {
      "filePath": "privacy.tsx"
    },
    "/terms": {
      "filePath": "terms.tsx"
    },
    "/_app/_auth": {
      "filePath": "_app/_auth.tsx",
      "parent": "/_app",
      "children": [
        "/_app/_auth/admin",
        "/_app/_auth/dashboard",
        "/_app/_auth/onboarding"
      ]
    },
    "/_app/_dev": {
      "filePath": "_app/_dev.tsx",
      "parent": "/_app",
      "children": [
        "/_app/_dev/component-library"
      ]
    },
    "/conflict-check/$token": {
      "filePath": "conflict-check.$token.tsx"
    },
    "/_app/_dev/component-library": {
      "filePath": "_app/_dev/component-library.tsx",
      "parent": "/_app/_dev"
    },
    "/_app/login": {
      "filePath": "_app/login",
      "parent": "/_app",
      "children": [
        "/_app/login/_layout"
      ]
    },
    "/_app/login/_layout": {
      "filePath": "_app/login/_layout.tsx",
      "parent": "/_app/login",
      "children": [
        "/_app/login/_layout/"
      ]
    },
    "/_app/_auth/admin": {
      "filePath": "_app/_auth/admin",
      "parent": "/_app/_auth",
      "children": [
        "/_app/_auth/admin/_layout"
      ]
    },
    "/_app/_auth/admin/_layout": {
      "filePath": "_app/_auth/admin/_layout.tsx",
      "parent": "/_app/_auth/admin",
      "children": [
        "/_app/_auth/admin/_layout/ai-usage",
        "/_app/_auth/admin/_layout/billing",
        "/_app/_auth/admin/_layout/cost-management",
        "/_app/_auth/admin/_layout/email-templates",
        "/_app/_auth/admin/_layout/infotrack",
        "/_app/_auth/admin/_layout/invitations",
        "/_app/_auth/admin/_layout/master-library",
        "/_app/_auth/admin/_layout/organisations",
        "/_app/_auth/admin/_layout/reducto",
        "/_app/_auth/admin/_layout/users",
        "/_app/_auth/admin/_layout/"
      ]
    },
    "/_app/_auth/dashboard": {
      "filePath": "_app/_auth/dashboard",
      "parent": "/_app/_auth",
      "children": [
        "/_app/_auth/dashboard/_layout"
      ]
    },
    "/_app/_auth/dashboard/_layout": {
      "filePath": "_app/_auth/dashboard/_layout.tsx",
      "parent": "/_app/_auth/dashboard",
      "children": [
        "/_app/_auth/dashboard/_layout/agent",
        "/_app/_auth/dashboard/_layout/automations",
        "/_app/_auth/dashboard/_layout/calendar",
        "/_app/_auth/dashboard/_layout/checkout",
        "/_app/_auth/dashboard/_layout/firm-contacts",
        "/_app/_auth/dashboard/_layout/inbox",
        "/_app/_auth/dashboard/_layout/jobs",
        "/_app/_auth/dashboard/_layout/mail",
        "/_app/_auth/dashboard/_layout/my-tasks",
        "/_app/_auth/dashboard/_layout/pre-appointment",
        "/_app/_auth/dashboard/_layout/pre-appointment-fields",
        "/_app/_auth/dashboard/_layout/pre-appointment-labels",
        "/_app/_auth/dashboard/_layout/pre-appointment-settings",
        "/_app/_auth/dashboard/_layout/pre-appointment-statuses",
        "/_app/_auth/dashboard/_layout/settings",
        "/_app/_auth/dashboard/_layout/task-labels",
        "/_app/_auth/dashboard/_layout/task-statuses",
        "/_app/_auth/dashboard/_layout/timesheet-approvals",
        "/_app/_auth/dashboard/_layout/timesheet-reports",
        "/_app/_auth/dashboard/_layout/timesheet-settings",
        "/_app/_auth/dashboard/_layout/timesheets",
        "/_app/_auth/dashboard/_layout/workflow-roles",
        "/_app/_auth/dashboard/_layout/workflows",
        "/_app/_auth/dashboard/_layout/"
      ]
    },
    "/_app/_auth/onboarding": {
      "filePath": "_app/_auth/onboarding",
      "parent": "/_app/_auth",
      "children": [
        "/_app/_auth/onboarding/_layout"
      ]
    },
    "/_app/_auth/onboarding/_layout": {
      "filePath": "_app/_auth/onboarding/_layout.tsx",
      "parent": "/_app/_auth/onboarding",
      "children": [
        "/_app/_auth/onboarding/_layout/organization"
      ]
    },
    "/_app/login/_layout/": {
      "filePath": "_app/login/_layout.index.tsx",
      "parent": "/_app/login/_layout"
    },
    "/_app/_auth/admin/_layout/ai-usage": {
      "filePath": "_app/_auth/admin/_layout.ai-usage.tsx",
      "parent": "/_app/_auth/admin/_layout"
    },
    "/_app/_auth/admin/_layout/billing": {
      "filePath": "_app/_auth/admin/_layout.billing.tsx",
      "parent": "/_app/_auth/admin/_layout"
    },
    "/_app/_auth/admin/_layout/cost-management": {
      "filePath": "_app/_auth/admin/_layout.cost-management.tsx",
      "parent": "/_app/_auth/admin/_layout"
    },
    "/_app/_auth/admin/_layout/email-templates": {
      "filePath": "_app/_auth/admin/_layout.email-templates.tsx",
      "parent": "/_app/_auth/admin/_layout"
    },
    "/_app/_auth/admin/_layout/infotrack": {
      "filePath": "_app/_auth/admin/_layout.infotrack.tsx",
      "parent": "/_app/_auth/admin/_layout"
    },
    "/_app/_auth/admin/_layout/invitations": {
      "filePath": "_app/_auth/admin/_layout.invitations.tsx",
      "parent": "/_app/_auth/admin/_layout"
    },
    "/_app/_auth/admin/_layout/master-library": {
      "filePath": "_app/_auth/admin/_layout.master-library.tsx",
      "parent": "/_app/_auth/admin/_layout"
    },
    "/_app/_auth/admin/_layout/organisations": {
      "filePath": "_app/_auth/admin/_layout.organisations.tsx",
      "parent": "/_app/_auth/admin/_layout",
      "children": [
        "/_app/_auth/admin/_layout/organisations/$orgId"
      ]
    },
    "/_app/_auth/admin/_layout/reducto": {
      "filePath": "_app/_auth/admin/_layout.reducto.tsx",
      "parent": "/_app/_auth/admin/_layout"
    },
    "/_app/_auth/admin/_layout/users": {
      "filePath": "_app/_auth/admin/_layout.users.tsx",
      "parent": "/_app/_auth/admin/_layout",
      "children": [
        "/_app/_auth/admin/_layout/users/$userId"
      ]
    },
    "/_app/_auth/dashboard/_layout/agent": {
      "filePath": "_app/_auth/dashboard/_layout.agent.tsx",
      "parent": "/_app/_auth/dashboard/_layout"
    },
    "/_app/_auth/dashboard/_layout/automations": {
      "filePath": "_app/_auth/dashboard/_layout.automations.tsx",
      "parent": "/_app/_auth/dashboard/_layout"
    },
    "/_app/_auth/dashboard/_layout/calendar": {
      "filePath": "_app/_auth/dashboard/_layout.calendar.tsx",
      "parent": "/_app/_auth/dashboard/_layout"
    },
    "/_app/_auth/dashboard/_layout/checkout": {
      "filePath": "_app/_auth/dashboard/_layout.checkout.tsx",
      "parent": "/_app/_auth/dashboard/_layout"
    },
    "/_app/_auth/dashboard/_layout/firm-contacts": {
      "filePath": "_app/_auth/dashboard/_layout.firm-contacts.tsx",
      "parent": "/_app/_auth/dashboard/_layout",
      "children": [
        "/_app/_auth/dashboard/_layout/firm-contacts/categories",
        "/_app/_auth/dashboard/_layout/firm-contacts/fields",
        "/_app/_auth/dashboard/_layout/firm-contacts/"
      ]
    },
    "/_app/_auth/dashboard/_layout/inbox": {
      "filePath": "_app/_auth/dashboard/_layout.inbox.tsx",
      "parent": "/_app/_auth/dashboard/_layout"
    },
    "/_app/_auth/dashboard/_layout/jobs": {
      "filePath": "_app/_auth/dashboard/_layout.jobs.tsx",
      "parent": "/_app/_auth/dashboard/_layout",
      "children": [
        "/_app/_auth/dashboard/_layout/jobs/$jobId",
        "/_app/_auth/dashboard/_layout/jobs/"
      ]
    },
    "/_app/_auth/dashboard/_layout/mail": {
      "filePath": "_app/_auth/dashboard/_layout.mail.tsx",
      "parent": "/_app/_auth/dashboard/_layout"
    },
    "/_app/_auth/dashboard/_layout/my-tasks": {
      "filePath": "_app/_auth/dashboard/_layout.my-tasks.tsx",
      "parent": "/_app/_auth/dashboard/_layout"
    },
    "/_app/_auth/dashboard/_layout/pre-appointment": {
      "filePath": "_app/_auth/dashboard/_layout.pre-appointment.tsx",
      "parent": "/_app/_auth/dashboard/_layout"
    },
    "/_app/_auth/dashboard/_layout/pre-appointment-fields": {
      "filePath": "_app/_auth/dashboard/_layout.pre-appointment-fields.tsx",
      "parent": "/_app/_auth/dashboard/_layout"
    },
    "/_app/_auth/dashboard/_layout/pre-appointment-labels": {
      "filePath": "_app/_auth/dashboard/_layout.pre-appointment-labels.tsx",
      "parent": "/_app/_auth/dashboard/_layout"
    },
    "/_app/_auth/dashboard/_layout/pre-appointment-settings": {
      "filePath": "_app/_auth/dashboard/_layout.pre-appointment-settings.tsx",
      "parent": "/_app/_auth/dashboard/_layout"
    },
    "/_app/_auth/dashboard/_layout/pre-appointment-statuses": {
      "filePath": "_app/_auth/dashboard/_layout.pre-appointment-statuses.tsx",
      "parent": "/_app/_auth/dashboard/_layout"
    },
    "/_app/_auth/dashboard/_layout/settings": {
      "filePath": "_app/_auth/dashboard/_layout.settings.tsx",
      "parent": "/_app/_auth/dashboard/_layout",
      "children": [
        "/_app/_auth/dashboard/_layout/settings/billing",
        "/_app/_auth/dashboard/_layout/settings/branding",
        "/_app/_auth/dashboard/_layout/settings/contact-roles",
        "/_app/_auth/dashboard/_layout/settings/docs",
        "/_app/_auth/dashboard/_layout/settings/fields",
        "/_app/_auth/dashboard/_layout/settings/help",
        "/_app/_auth/dashboard/_layout/settings/integrations",
        "/_app/_auth/dashboard/_layout/settings/jobcode",
        "/_app/_auth/dashboard/_layout/settings/organization",
        "/_app/_auth/dashboard/_layout/settings/public-holidays",
        "/_app/_auth/dashboard/_layout/settings/report-templates",
        "/_app/_auth/dashboard/_layout/settings/snippets",
        "/_app/_auth/dashboard/_layout/settings/"
      ]
    },
    "/_app/_auth/dashboard/_layout/task-labels": {
      "filePath": "_app/_auth/dashboard/_layout.task-labels.tsx",
      "parent": "/_app/_auth/dashboard/_layout"
    },
    "/_app/_auth/dashboard/_layout/task-statuses": {
      "filePath": "_app/_auth/dashboard/_layout.task-statuses.tsx",
      "parent": "/_app/_auth/dashboard/_layout"
    },
    "/_app/_auth/dashboard/_layout/timesheet-approvals": {
      "filePath": "_app/_auth/dashboard/_layout.timesheet-approvals.tsx",
      "parent": "/_app/_auth/dashboard/_layout"
    },
    "/_app/_auth/dashboard/_layout/timesheet-reports": {
      "filePath": "_app/_auth/dashboard/_layout.timesheet-reports.tsx",
      "parent": "/_app/_auth/dashboard/_layout"
    },
    "/_app/_auth/dashboard/_layout/timesheet-settings": {
      "filePath": "_app/_auth/dashboard/_layout.timesheet-settings.tsx",
      "parent": "/_app/_auth/dashboard/_layout"
    },
    "/_app/_auth/dashboard/_layout/timesheets": {
      "filePath": "_app/_auth/dashboard/_layout.timesheets.tsx",
      "parent": "/_app/_auth/dashboard/_layout"
    },
    "/_app/_auth/dashboard/_layout/workflow-roles": {
      "filePath": "_app/_auth/dashboard/_layout.workflow-roles.tsx",
      "parent": "/_app/_auth/dashboard/_layout"
    },
    "/_app/_auth/dashboard/_layout/workflows": {
      "filePath": "_app/_auth/dashboard/_layout.workflows.tsx",
      "parent": "/_app/_auth/dashboard/_layout",
      "children": [
        "/_app/_auth/dashboard/_layout/workflows/$workflowId",
        "/_app/_auth/dashboard/_layout/workflows/"
      ]
    },
    "/_app/_auth/onboarding/_layout/organization": {
      "filePath": "_app/_auth/onboarding/_layout.organization.tsx",
      "parent": "/_app/_auth/onboarding/_layout"
    },
    "/_app/_auth/admin/_layout/": {
      "filePath": "_app/_auth/admin/_layout.index.tsx",
      "parent": "/_app/_auth/admin/_layout"
    },
    "/_app/_auth/dashboard/_layout/": {
      "filePath": "_app/_auth/dashboard/_layout.index.tsx",
      "parent": "/_app/_auth/dashboard/_layout"
    },
    "/_app/_auth/admin/_layout/organisations/$orgId": {
      "filePath": "_app/_auth/admin/_layout.organisations.$orgId.tsx",
      "parent": "/_app/_auth/admin/_layout/organisations"
    },
    "/_app/_auth/admin/_layout/users/$userId": {
      "filePath": "_app/_auth/admin/_layout.users.$userId.tsx",
      "parent": "/_app/_auth/admin/_layout/users"
    },
    "/_app/_auth/dashboard/_layout/firm-contacts/categories": {
      "filePath": "_app/_auth/dashboard/_layout.firm-contacts.categories.tsx",
      "parent": "/_app/_auth/dashboard/_layout/firm-contacts"
    },
    "/_app/_auth/dashboard/_layout/firm-contacts/fields": {
      "filePath": "_app/_auth/dashboard/_layout.firm-contacts.fields.tsx",
      "parent": "/_app/_auth/dashboard/_layout/firm-contacts"
    },
    "/_app/_auth/dashboard/_layout/jobs/$jobId": {
      "filePath": "_app/_auth/dashboard/_layout.jobs.$jobId.tsx",
      "parent": "/_app/_auth/dashboard/_layout/jobs",
      "children": [
        "/_app/_auth/dashboard/_layout/jobs/$jobId/agent",
        "/_app/_auth/dashboard/_layout/jobs/$jobId/calendar",
        "/_app/_auth/dashboard/_layout/jobs/$jobId/contacts",
        "/_app/_auth/dashboard/_layout/jobs/$jobId/day-one",
        "/_app/_auth/dashboard/_layout/jobs/$jobId/gather",
        "/_app/_auth/dashboard/_layout/jobs/$jobId/gather-information",
        "/_app/_auth/dashboard/_layout/jobs/$jobId/generate-precedents",
        "/_app/_auth/dashboard/_layout/jobs/$jobId/mail",
        "/_app/_auth/dashboard/_layout/jobs/$jobId/plan",
        "/_app/_auth/dashboard/_layout/jobs/$jobId/recoveries",
        "/_app/_auth/dashboard/_layout/jobs/$jobId/reporting",
        "/_app/_auth/dashboard/_layout/jobs/$jobId/review",
        "/_app/_auth/dashboard/_layout/jobs/$jobId/searches",
        "/_app/_auth/dashboard/_layout/jobs/$jobId/settings",
        "/_app/_auth/dashboard/_layout/jobs/$jobId/summaries",
        "/_app/_auth/dashboard/_layout/jobs/$jobId/timesheets",
        "/_app/_auth/dashboard/_layout/jobs/$jobId/"
      ]
    },
    "/_app/_auth/dashboard/_layout/settings/billing": {
      "filePath": "_app/_auth/dashboard/_layout.settings.billing.tsx",
      "parent": "/_app/_auth/dashboard/_layout/settings"
    },
    "/_app/_auth/dashboard/_layout/settings/branding": {
      "filePath": "_app/_auth/dashboard/_layout.settings.branding.tsx",
      "parent": "/_app/_auth/dashboard/_layout/settings"
    },
    "/_app/_auth/dashboard/_layout/settings/contact-roles": {
      "filePath": "_app/_auth/dashboard/_layout.settings.contact-roles.tsx",
      "parent": "/_app/_auth/dashboard/_layout/settings"
    },
    "/_app/_auth/dashboard/_layout/settings/docs": {
      "filePath": "_app/_auth/dashboard/_layout.settings.docs.tsx",
      "parent": "/_app/_auth/dashboard/_layout/settings"
    },
    "/_app/_auth/dashboard/_layout/settings/fields": {
      "filePath": "_app/_auth/dashboard/_layout.settings.fields.tsx",
      "parent": "/_app/_auth/dashboard/_layout/settings"
    },
    "/_app/_auth/dashboard/_layout/settings/help": {
      "filePath": "_app/_auth/dashboard/_layout.settings.help.tsx",
      "parent": "/_app/_auth/dashboard/_layout/settings"
    },
    "/_app/_auth/dashboard/_layout/settings/integrations": {
      "filePath": "_app/_auth/dashboard/_layout.settings.integrations.tsx",
      "parent": "/_app/_auth/dashboard/_layout/settings"
    },
    "/_app/_auth/dashboard/_layout/settings/jobcode": {
      "filePath": "_app/_auth/dashboard/_layout.settings.jobcode.tsx",
      "parent": "/_app/_auth/dashboard/_layout/settings"
    },
    "/_app/_auth/dashboard/_layout/settings/organization": {
      "filePath": "_app/_auth/dashboard/_layout.settings.organization.tsx",
      "parent": "/_app/_auth/dashboard/_layout/settings"
    },
    "/_app/_auth/dashboard/_layout/settings/public-holidays": {
      "filePath": "_app/_auth/dashboard/_layout.settings.public-holidays.tsx",
      "parent": "/_app/_auth/dashboard/_layout/settings"
    },
    "/_app/_auth/dashboard/_layout/settings/report-templates": {
      "filePath": "_app/_auth/dashboard/_layout.settings.report-templates.tsx",
      "parent": "/_app/_auth/dashboard/_layout/settings"
    },
    "/_app/_auth/dashboard/_layout/settings/snippets": {
      "filePath": "_app/_auth/dashboard/_layout.settings.snippets.tsx",
      "parent": "/_app/_auth/dashboard/_layout/settings"
    },
    "/_app/_auth/dashboard/_layout/workflows/$workflowId": {
      "filePath": "_app/_auth/dashboard/_layout.workflows.$workflowId.tsx",
      "parent": "/_app/_auth/dashboard/_layout/workflows"
    },
    "/_app/_auth/dashboard/_layout/firm-contacts/": {
      "filePath": "_app/_auth/dashboard/_layout.firm-contacts.index.tsx",
      "parent": "/_app/_auth/dashboard/_layout/firm-contacts"
    },
    "/_app/_auth/dashboard/_layout/jobs/": {
      "filePath": "_app/_auth/dashboard/_layout.jobs.index.tsx",
      "parent": "/_app/_auth/dashboard/_layout/jobs"
    },
    "/_app/_auth/dashboard/_layout/settings/": {
      "filePath": "_app/_auth/dashboard/_layout.settings.index.tsx",
      "parent": "/_app/_auth/dashboard/_layout/settings"
    },
    "/_app/_auth/dashboard/_layout/workflows/": {
      "filePath": "_app/_auth/dashboard/_layout.workflows.index.tsx",
      "parent": "/_app/_auth/dashboard/_layout/workflows"
    },
    "/_app/_auth/dashboard/_layout/jobs/$jobId/agent": {
      "filePath": "_app/_auth/dashboard/_layout.jobs.$jobId.agent.tsx",
      "parent": "/_app/_auth/dashboard/_layout/jobs/$jobId"
    },
    "/_app/_auth/dashboard/_layout/jobs/$jobId/calendar": {
      "filePath": "_app/_auth/dashboard/_layout.jobs.$jobId.calendar.tsx",
      "parent": "/_app/_auth/dashboard/_layout/jobs/$jobId",
      "children": [
        "/_app/_auth/dashboard/_layout/jobs/$jobId/calendar/overview",
        "/_app/_auth/dashboard/_layout/jobs/$jobId/calendar/review-windows",
        "/_app/_auth/dashboard/_layout/jobs/$jobId/calendar/tasks",
        "/_app/_auth/dashboard/_layout/jobs/$jobId/calendar/"
      ]
    },
    "/_app/_auth/dashboard/_layout/jobs/$jobId/contacts": {
      "filePath": "_app/_auth/dashboard/_layout.jobs.$jobId.contacts.tsx",
      "parent": "/_app/_auth/dashboard/_layout/jobs/$jobId"
    },
    "/_app/_auth/dashboard/_layout/jobs/$jobId/day-one": {
      "filePath": "_app/_auth/dashboard/_layout.jobs.$jobId.day-one.tsx",
      "parent": "/_app/_auth/dashboard/_layout/jobs/$jobId"
    },
    "/_app/_auth/dashboard/_layout/jobs/$jobId/gather": {
      "filePath": "_app/_auth/dashboard/_layout.jobs.$jobId.gather.tsx",
      "parent": "/_app/_auth/dashboard/_layout/jobs/$jobId",
      "children": [
        "/_app/_auth/dashboard/_layout/jobs/$jobId/gather/"
      ]
    },
    "/_app/_auth/dashboard/_layout/jobs/$jobId/gather-information": {
      "filePath": "_app/_auth/dashboard/_layout.jobs.$jobId.gather-information.tsx",
      "parent": "/_app/_auth/dashboard/_layout/jobs/$jobId"
    },
    "/_app/_auth/dashboard/_layout/jobs/$jobId/generate-precedents": {
      "filePath": "_app/_auth/dashboard/_layout.jobs.$jobId.generate-precedents.tsx",
      "parent": "/_app/_auth/dashboard/_layout/jobs/$jobId"
    },
    "/_app/_auth/dashboard/_layout/jobs/$jobId/mail": {
      "filePath": "_app/_auth/dashboard/_layout.jobs.$jobId.mail.tsx",
      "parent": "/_app/_auth/dashboard/_layout/jobs/$jobId"
    },
    "/_app/_auth/dashboard/_layout/jobs/$jobId/plan": {
      "filePath": "_app/_auth/dashboard/_layout.jobs.$jobId.plan.tsx",
      "parent": "/_app/_auth/dashboard/_layout/jobs/$jobId"
    },
    "/_app/_auth/dashboard/_layout/jobs/$jobId/recoveries": {
      "filePath": "_app/_auth/dashboard/_layout.jobs.$jobId.recoveries.tsx",
      "parent": "/_app/_auth/dashboard/_layout/jobs/$jobId",
      "children": [
        "/_app/_auth/dashboard/_layout/jobs/$jobId/recoveries/$section",
        "/_app/_auth/dashboard/_layout/jobs/$jobId/recoveries/"
      ]
    },
    "/_app/_auth/dashboard/_layout/jobs/$jobId/reporting": {
      "filePath": "_app/_auth/dashboard/_layout.jobs.$jobId.reporting.tsx",
      "parent": "/_app/_auth/dashboard/_layout/jobs/$jobId"
    },
    "/_app/_auth/dashboard/_layout/jobs/$jobId/review": {
      "filePath": "_app/_auth/dashboard/_layout.jobs.$jobId.review.tsx",
      "parent": "/_app/_auth/dashboard/_layout/jobs/$jobId",
      "children": [
        "/_app/_auth/dashboard/_layout/jobs/$jobId/review/$agent",
        "/_app/_auth/dashboard/_layout/jobs/$jobId/review/"
      ]
    },
    "/_app/_auth/dashboard/_layout/jobs/$jobId/searches": {
      "filePath": "_app/_auth/dashboard/_layout.jobs.$jobId.searches.tsx",
      "parent": "/_app/_auth/dashboard/_layout/jobs/$jobId",
      "children": [
        "/_app/_auth/dashboard/_layout/jobs/$jobId/searches/infotrack",
        "/_app/_auth/dashboard/_layout/jobs/$jobId/searches/kyc-aml",
        "/_app/_auth/dashboard/_layout/jobs/$jobId/searches/web",
        "/_app/_auth/dashboard/_layout/jobs/$jobId/searches/"
      ]
    },
    "/_app/_auth/dashboard/_layout/jobs/$jobId/settings": {
      "filePath": "_app/_auth/dashboard/_layout.jobs.$jobId.settings.tsx",
      "parent": "/_app/_auth/dashboard/_layout/jobs/$jobId"
    },
    "/_app/_auth/dashboard/_layout/jobs/$jobId/summaries": {
      "filePath": "_app/_auth/dashboard/_layout.jobs.$jobId.summaries.tsx",
      "parent": "/_app/_auth/dashboard/_layout/jobs/$jobId",
      "children": [
        "/_app/_auth/dashboard/_layout/jobs/$jobId/summaries/$agent",
        "/_app/_auth/dashboard/_layout/jobs/$jobId/summaries/"
      ]
    },
    "/_app/_auth/dashboard/_layout/jobs/$jobId/timesheets": {
      "filePath": "_app/_auth/dashboard/_layout.jobs.$jobId.timesheets.tsx",
      "parent": "/_app/_auth/dashboard/_layout/jobs/$jobId"
    },
    "/_app/_auth/dashboard/_layout/jobs/$jobId/": {
      "filePath": "_app/_auth/dashboard/_layout.jobs.$jobId.index.tsx",
      "parent": "/_app/_auth/dashboard/_layout/jobs/$jobId"
    },
    "/_app/_auth/dashboard/_layout/jobs/$jobId/calendar/overview": {
      "filePath": "_app/_auth/dashboard/_layout.jobs.$jobId.calendar.overview.tsx",
      "parent": "/_app/_auth/dashboard/_layout/jobs/$jobId/calendar"
    },
    "/_app/_auth/dashboard/_layout/jobs/$jobId/calendar/review-windows": {
      "filePath": "_app/_auth/dashboard/_layout.jobs.$jobId.calendar.review-windows.tsx",
      "parent": "/_app/_auth/dashboard/_layout/jobs/$jobId/calendar"
    },
    "/_app/_auth/dashboard/_layout/jobs/$jobId/calendar/tasks": {
      "filePath": "_app/_auth/dashboard/_layout.jobs.$jobId.calendar.tasks.tsx",
      "parent": "/_app/_auth/dashboard/_layout/jobs/$jobId/calendar"
    },
    "/_app/_auth/dashboard/_layout/jobs/$jobId/recoveries/$section": {
      "filePath": "_app/_auth/dashboard/_layout.jobs.$jobId.recoveries.$section.tsx",
      "parent": "/_app/_auth/dashboard/_layout/jobs/$jobId/recoveries"
    },
    "/_app/_auth/dashboard/_layout/jobs/$jobId/review/$agent": {
      "filePath": "_app/_auth/dashboard/_layout.jobs.$jobId.review.$agent.tsx",
      "parent": "/_app/_auth/dashboard/_layout/jobs/$jobId/review"
    },
    "/_app/_auth/dashboard/_layout/jobs/$jobId/searches/infotrack": {
      "filePath": "_app/_auth/dashboard/_layout.jobs.$jobId.searches.infotrack.tsx",
      "parent": "/_app/_auth/dashboard/_layout/jobs/$jobId/searches"
    },
    "/_app/_auth/dashboard/_layout/jobs/$jobId/searches/kyc-aml": {
      "filePath": "_app/_auth/dashboard/_layout.jobs.$jobId.searches.kyc-aml.tsx",
      "parent": "/_app/_auth/dashboard/_layout/jobs/$jobId/searches"
    },
    "/_app/_auth/dashboard/_layout/jobs/$jobId/searches/web": {
      "filePath": "_app/_auth/dashboard/_layout.jobs.$jobId.searches.web.tsx",
      "parent": "/_app/_auth/dashboard/_layout/jobs/$jobId/searches"
    },
    "/_app/_auth/dashboard/_layout/jobs/$jobId/summaries/$agent": {
      "filePath": "_app/_auth/dashboard/_layout.jobs.$jobId.summaries.$agent.tsx",
      "parent": "/_app/_auth/dashboard/_layout/jobs/$jobId/summaries"
    },
    "/_app/_auth/dashboard/_layout/jobs/$jobId/calendar/": {
      "filePath": "_app/_auth/dashboard/_layout.jobs.$jobId.calendar.index.tsx",
      "parent": "/_app/_auth/dashboard/_layout/jobs/$jobId/calendar"
    },
    "/_app/_auth/dashboard/_layout/jobs/$jobId/gather/": {
      "filePath": "_app/_auth/dashboard/_layout.jobs.$jobId.gather.index.tsx",
      "parent": "/_app/_auth/dashboard/_layout/jobs/$jobId/gather"
    },
    "/_app/_auth/dashboard/_layout/jobs/$jobId/recoveries/": {
      "filePath": "_app/_auth/dashboard/_layout.jobs.$jobId.recoveries.index.tsx",
      "parent": "/_app/_auth/dashboard/_layout/jobs/$jobId/recoveries"
    },
    "/_app/_auth/dashboard/_layout/jobs/$jobId/review/": {
      "filePath": "_app/_auth/dashboard/_layout.jobs.$jobId.review.index.tsx",
      "parent": "/_app/_auth/dashboard/_layout/jobs/$jobId/review"
    },
    "/_app/_auth/dashboard/_layout/jobs/$jobId/searches/": {
      "filePath": "_app/_auth/dashboard/_layout.jobs.$jobId.searches.index.tsx",
      "parent": "/_app/_auth/dashboard/_layout/jobs/$jobId/searches"
    },
    "/_app/_auth/dashboard/_layout/jobs/$jobId/summaries/": {
      "filePath": "_app/_auth/dashboard/_layout.jobs.$jobId.summaries.index.tsx",
      "parent": "/_app/_auth/dashboard/_layout/jobs/$jobId/summaries"
    }
  }
}
ROUTE_MANIFEST_END */
